import React, { useContext, useEffect, useState, useRef } from "react";
import moment from "moment";
import { API, graphqlOperation } from "aws-amplify";
import { Button, Col, Modal, Row, Container, Card, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDate, formatUSNumber, getId, numberWithCommas, statusStyles } from "../../../Utility";
import envFile from "../../../envFile";
import { Context } from "../../../Utility/ContextManager";
import { KeyboardDatePicker } from "@material-ui/pickers";
import toast from "react-hot-toast";
import FormInput from "../../../Utility/FormInput";
import AddBankAccount from "../../bankAccount/components/AddBankAccount";
import { sendInstantRent, getorcreateForteCustomerToken } from "../../../graphql/queries";
import { crudCommunications, crudPropertyUnitLease } from "../../../graphql/mutations";
import CalenderIcon from "../../../assets/images/calendar-icon.svg";
import LeaseSummary from "./LeaseSummary";
import { createRecordTB, listTenantCategoryFN, updateRecordTB } from "../../../Utility/ApiService";
//For future use(PropertyLeasePayment table individual payments)
//import AllPaymentsDue from "./AllPaymentsDue";
import PaymentConfirmedModal from "./modals/PaymentConfirmedModal";
import AutomaticPaymentScheduleModal from "./modals/AutomaticPaymentScheduleModal";
import PaymentMethodSelectionModal from "./modals/PaymentMethodSelectionModal";
import CreditCardPaymentModal from "./modals/CreditCardPaymentModal";
import Address from "../components/Address";
import PropertyManager from "./PropertyManager";
import DocumentList from "./DocumentList";
import RentersInsurance from "./RentersInsurance";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { SpinnerLoading } from "../../../components/Loadings";
import { MyDropzone } from "./Dropzone";
import useAnalytics from "../../../analytics/useAnalytics";
import EVENTS from "../../../analytics/events";
import { submitWithIdempotencyKey, handlePaymentError } from "./paymentIdempotency";

const PaymentDues = ({
  propertyDetails,
  propertyDetail,
  getAllBankAccounts,
  setLoading,
  getBanksTransaction,
  allTransactions,
  fetchAllPropertyUnitDocs,
  deleteDocument,
  paymentsDue,
  upcomingPayments,
  getUpcomingPayments,
  leases,
  unfilteredLeases,
  propertyPhotos,
  tenantLedger,
  getTenantLedger,
  payabliLoading,
  forteMappingData,
  tenantWidgets,
}) => {
  const { user, bankAccounts, propertyManagerInfo, dueData, setDueData } = useContext(Context);
  const isMember = user?.is_member === 1;
  const navigate = useNavigate();
  const { track } = useAnalytics();
  const [automaticShow, setAutomaticShow] = useState(false);
  const [payRentModalShow, setPayRentModalShow] = useState(false);
  const [selectedType, setSelectedType] = useState();
  const [selectedBankAccount, setSelectedBankAccount] = useState();
  const [isDefaultAutomatic, setIsDefaultAutomnatic] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [autoPaymentBank, setAutoPaymentBank] = useState();
  const [inputAmount, setInputAmount] = useState(0);
  const [rentAmount, setRentAmount] = useState(0);
  const [tenantCategories, setTenantCategories] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [scheduledPaymentSuccessModal, setScheduledPaymentSuccessModal] = useState(false);
  const [deactivatedAutomaticPaymentModalShow, setDeactivatedAutomaticPaymentModalShow] = useState(false);
  const [successfulPaymentScreenEditMode, setSuccessfulPaymentScreenEditMode] = useState(false);
  const [editModeCategory, setEditModeCategory] = useState("");
  const [editModeDate, setEditModeDate] = useState("");
  const [editModeAmount, setEditModeAmount] = useState(0);
  const [editModePaymentId, setEditModePaymentId] = useState("");
  const [selectedLeaseId, setSelectedLeaseId] = useState(null);
  const [selectedLeaseObj, setSelectedLeaseObj] = useState(null);
  const [isPastDue, setIsPastDue] = useState(false);
  const [submittedAmount, setSubmittedAmount] = useState("");
  const [submittedAutomaticPaymentAmount, setSubmittedAutomaticPaymentAmount] = useState("");
  const [submittedAutomaticPaymentDate, setSubmittedAutomaticPaymentDate] = useState("");
  const [currentLease, setCurrentLease] = useState({});
  const [tenantLedgerAndProcessing, setTenantLedgerAndProcessing] = useState({
    scheduled: [],
    tenantLedger: [],
  });
  // Adding Forte state specific variables
  const [showForteModal, setShowForteModal] = useState(false);
  const forteButtonRef = useRef(null);
  const lastLambdaResponse = useRef(null);

  const [inputValues, setInputValues] = useState({
    amount: "",
    date: "",
    checkedPayFull: true,
    checkedPayPartial: false,
  });
  const [pendingAutopayRecord, setPendingAutopayRecord] = useState(null);
  const [allModals, setAllModals] = useState({
    paymentConfirmationShow: false,
    automaticPaymentScheduleModalShow: false,
    paymentMethodSelectionShow: false,
    automaticPaymentConfirmationShow: false,
    creditCardPaymentShow: false,
    rentMismatchModal: false,
  });
  const {
    category = "",
    transaction_category_id = "",
    is_rent = "",
  } = tenantCategories.find((item) => item?.id === selectedType) || {};
  const { dueAmount, dueDate } = dueData;

  const selectPropertyDetail = propertyDetails?.find((item) =>
    category === "Security Deposit" ? item.collect_deposit === 1 : item.collect_rent === 1
  );
  // ARR: source the in-flight check from tenantLedger (refreshed via getTenantLedger
  // after every successful payment) instead of allTransactions, which is only
  // refetched when a pending payment already existed — so the first duplicate
  // submitted without a page reload previously bypassed the confirmation modal.
  const checkTransaction = tenantLedger?.filter(
    (t) =>
      moment(t?.date)?.isSameOrBefore(moment(selectedDate), "day") &&
      (is_rent ? t?.category === category : false) &&
      t?.transaction_type === "CREDIT" &&
      t?.status === "PENDING"
  );

  const updateModalShow = (modalName, value) => {
    setAllModals((prev) => ({ ...prev, [modalName]: value }));
  };

  // Calculate UTC ticks locally
  const getForteUTCTicks = async () => {
    const ticksAtEpoch = 621355968000000000; // Ticks at 1970-01-01T00:00:00Z
    const nowUtc = Date.now(); // current UTC in ms since 1970
    const ticksNow = ticksAtEpoch + nowUtc * 10000; // Convert ms to ticks
    const ticksString = ticksNow.toString();

    // Add detailed logging
    console.log("Forte UTC ticks calculation:", {
      epochTicks: ticksAtEpoch,
      currentUtcMs: nowUtc,
      currentDate: new Date().toISOString(),
      calculatedTicks: ticksString,
      ticksLength: ticksString.length,
    });

    return ticksString;
  };

  const resetValues = () => {
    //setSubmittedAmount("");
    setSelectedDate(new Date());
    setInputValues({
      //checkedPayFull: true,
      //checkedPayPartial: false,
      ...inputValues,
      amount: "",
      date: "",
    });
    const isHOA = propertyDetail?.property_type === "HOA";
    const isMember = user?.is_member === 1;

      // Debug logging - add this block
      console.log("Reset Values Debug:", {
        isHOA,
        isMember,
        propertyType: propertyDetail?.property_type,
        tenantCategories,
      });
    
    // ARR-1353 - Default to common charges for members and rent for residents
    let fallbackCategoryId = tenantCategories?.[0]?.id || null;

    if (Array.isArray(tenantCategories) && tenantCategories.length > 0) {
      if (isHOA) {
        const hoaDuesCategory = tenantCategories.find(item => item?.id === 21);
        setSelectedType(hoaDuesCategory?.id || fallbackCategoryId);
        console.log("Setting HOA category:", hoaDuesCategory || "FALLBACK");
      } else if (isMember) {
        const commonChargesCategory = tenantCategories.find(item => item?.id === 11);
        setSelectedType(commonChargesCategory?.id || fallbackCategoryId);
        console.log("Setting Member category:", commonChargesCategory || "FALLBACK");
      } else {
        const rentCategory = tenantCategories.find(item => item?.is_rent === 1);
        setSelectedType(rentCategory?.id || fallbackCategoryId);
        console.log("Setting Rent category:", rentCategory || "FALLBACK");
      }
    } else {
      console.debug("tenantCategories missing or invalid; cannot set default category.");
      setSelectedType("");
    }

    const amount =
      category === "Security Deposit"
        ? propertyDetail?.security_deposit
        : category === "Other"
        ? 0
        : selectPropertyDetail?.total_due > 0
        ? 0
        : Math.abs(selectPropertyDetail?.total_due);
    if (amount) {
      setInputAmount(Number(amount));
    }

    resetSelectedBankAccount();
    // const rentCategory = tenantCategories?.find((item) => item?.is_rent === 1);
    // setSelectedType(rentCategory?.id || tenantCategories?.[0]?.id || null);
  };

  // Store last signed values
  const lastSignedValues = useRef({
    amount: null,
    paymentDate: null,
    category: null,
  });

  // Effect to refresh Forte signature every 20 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      // Only refresh if the button exists and we have a current lease
      if (forteButtonRef.current && (isMember ? selectedLeaseObj : currentLease) && lastLambdaResponse.current) {
         // const currentLeaseObj = isMember ? selectedLeaseObj : currentLease;
        // const categoryObj = tenantCategories?.find((item) => item?.id === Number(selectedType));
        // const paymentCategory = categoryObj?.category || "RENT";
        //  const amount = inputValues?.checkedPayFull ? dueAmount : inputAmount;

        // Get fresh UTC ticks
        getForteUTCTicks().then((utcTicks) => {
          // Parse the stored response
          let parsedResponse;
          try {
            parsedResponse =
              typeof lastLambdaResponse.current.response === "string"
                ? JSON.parse(lastLambdaResponse.current.response)
                : lastLambdaResponse.current.response;
          } catch (e) {
            console.error("Error parsing stored response:", e);
            parsedResponse = {};
          }

          // Update signature and UTC time directly
          forteButtonRef.current.setAttribute("signature", parsedResponse.signature || "");
          forteButtonRef.current.setAttribute("utc_time", utcTicks || "");

          console.log("Refreshed signature and UTC time");
        });
      }
    }, 20 * 60 * 1000); // Every 20 minutes

    return () => clearInterval(interval);
  }, [selectedLeaseObj, currentLease, selectedType, inputAmount, dueAmount, inputValues]);

  // Dynamically load Forte SDK script when modal opens
  useEffect(() => {
    if (showForteModal) {
      const button = document.getElementById("forte-init-button");
      if (button) {
        button.setAttribute("method", "sale");
        button.setAttribute("version_number", "2.0");
        button.setAttribute("hash_method", "sha256");
        button.setAttribute("location_id", forteMappingData?.forte_location_id || "373367");
        button.setAttribute("api_access_id", forteMappingData?.forte_org_id || "ff1572b26408215cfc4fec6f2309be9b");
        button.setAttribute("order_number", "ORDER-placeholder");
        button.setAttribute("signature", "placeholder");
        button.setAttribute("utc_time", "000000000000000000");
        button.setAttribute("customer_token", "placeholder");
        button.setAttribute("callback", "oncallback");
      }

      // Add this to initialize lastSignedValues when modal opens
      const initialAmount = parseFloat(
        inputValues?.checkedPayFull ? dueAmount : inputAmount
      ).toFixed(2);
      
      // Get the category from selectedType
      const categoryObj = tenantCategories?.find((item) => item?.id === Number(selectedType));
      const paymentCategory = categoryObj?.category || "RENT";
      
      lastSignedValues.current = {
        amount: initialAmount,
        paymentDate: selectedDate?.getTime(),
        category: paymentCategory,
      };

      if (!window.ForteCheckout) {
        console.log("Loading Forte SDK...");
        const script = document.createElement("script");
        script.src = "https://sandbox.forte.net/checkout/v2/js";
        script.async = true;
        script.onload = () => {
          console.log("Forte SDK loaded, ForteCheckout available:", !!window.ForteCheckout);
          getSignedParamsAndLaunch().catch(error => {
            console.error("Error launching checkout:", error);
            toast.error("Failed to initialize payment processor page. Please try again or contact Arrivo support.");
          });
        };
        script.onerror = (error) => {
          console.error("Failed to load Forte SDK:", error);
          toast.error("Failed to load payment processor page. Please try again or contact Arrivo support.");
        };
        document.body.appendChild(script);
      } else {
        getSignedParamsAndLaunch().catch(error => {
          console.error("Error launching checkout:", error);
          toast.error("Failed to initialize payment processor page. Please try again or contact Arrivo support.");
        });
      }
    }
  }, [showForteModal]);

  // useEffect to detect changes and regenerate signature (around line 240)
  useEffect(() => {
    if (!showForteModal) return;

    const currentAmount = parseFloat(
      inputValues?.checkedPayFull ? dueAmount : inputAmount
    ).toFixed(2);

    // Use selectedDate instead of paymentDate
    const currentDate = selectedDate?.getTime();
    
    // Get the category from selectedType
    const categoryObj = tenantCategories?.find((item) => item?.id === Number(selectedType));
    const currentCategory = categoryObj?.category || "RENT";

    const hasChanged =
      currentAmount !== lastSignedValues.current.amount ||
      currentDate !== lastSignedValues.current.paymentDate ||
      currentCategory !== lastSignedValues.current.category;

    if (!hasChanged) return;

    console.log("Detected change in amount/date/category — regenerating signature...");
    
    const timer = setTimeout(() => {
      getSignedParamsAndLaunch();
      lastSignedValues.current = {
        amount: currentAmount,
        paymentDate: currentDate,
        category: currentCategory,
      };
    }, 500);

    return () => clearTimeout(timer);
  }, [
    inputValues?.checkedPayFull,
    inputAmount,
    dueAmount,
    selectedDate,
    selectedType,
    tenantCategories,
    showForteModal
  ]);

  useEffect(() => {
    listTenantCategoryFN().then((data) => {
      const sortedData = data?.sort((a, b) => a?.category.localeCompare(b?.category));
      setTenantCategories(sortedData);
      // console.log("isMember:", user.is_member); // Log isMember value
      // ARR - 1353 - set default category = common charges for members else rent
      const isHOA = propertyDetail?.property_type === "HOA";
      if (isHOA) {
        const hoaCategory = sortedData?.find((item) => item?.id === 21);
        setSelectedType(hoaCategory?.id || data?.[0]?.id || null);
      } else if (user.is_member === 1) {
        const commonChargesCategory = sortedData?.find((item) => item?.id === 11);
        setSelectedType(commonChargesCategory?.id || data?.[0]?.id || null);
      } else {
        const rentCategory = sortedData?.find((item) => item?.is_rent === 1);
        setSelectedType(rentCategory?.id || data?.[0]?.id || null);
      }
      // console.log("All Tenant Categories:", sortedData); // Log all tenant categories
    });
  }, [propertyDetail]);

  useEffect(() => {
    if (tenantLedger) {
      setTenantLedgerAndProcessing({ ...tenantLedgerAndProcessing, tenantLedger: tenantLedger });
    }
  }, [tenantLedger]);
  useEffect(() => {
    if (propertyDetail) {
      const obj = getDueData();
      setDueData(obj);
    }
  }, [isMember, propertyDetail]);
  useEffect(() => {
    if (upcomingPayments?.find((item) => item.repeat_payment === 1 || item?.member_auto_payment === 1)) {
      setIsDefaultAutomnatic(true);
    }
    const isHOA = propertyDetail?.property_type === "HOA";
    const formattedUpcomingPayments = upcomingPayments.map((payment) => ({
      id: payment.id,
      amount: payment.payment_amount,
      date: `${payment.next_occurance}T00:00:00.000Z`,
      transaction_type: "CREDIT",
      account_number: payment.account_number,
      purpose: isHOA ? "HOA Dues" : payment.member_auto_payment === 1 ? "Common Charges" : payment.category, // ARR - 1353 - set default category = common charges for members else whatever was selected
      category: isHOA ? "HOA Dues" : payment.member_auto_payment === 1 ? "Common Charges" : payment.category, // ARR - 1353 - set default category = common charges for members else whatever was selected
      status: payment?.repeat_payment === 1 ? "AUTOMATIC" : "SCHEDULED",
      member_auto_payment: payment?.member_auto_payment,
    }));
    //sort by date
    const sortedUpcomingPayments = formattedUpcomingPayments?.sort((a, b) => moment(b?.date).diff(moment(a?.date)));
    setTenantLedgerAndProcessing({ ...tenantLedgerAndProcessing, scheduled: sortedUpcomingPayments });
    //setProcessingPayments({ ...processingPayments, scheduled: formattedUpcomingPayments });
  }, [upcomingPayments]);

  useEffect(() => {
    const defaultBankAccount = bankAccounts?.find((item) => item?.default_bank_account === 1);
    if (defaultBankAccount) {
      setSelectedBankAccount(defaultBankAccount);
    }
  }, [bankAccounts]);

  useEffect(() => {
    if (leases) {
      const relevantLease = getRelevantLease(leases);
      if (relevantLease?.length > 0) {
        setIsPastDue(relevantLease[0]?.status === "PASTDUE");
        setCurrentLease(relevantLease[0]);
      }
    }
  }, [leases]);

  useEffect(() => {
    if (selectedType) {
      const amount =
        category === "Security Deposit"
          ? propertyDetail?.security_deposit
          : category === "Other"
          ? 0
          : selectPropertyDetail?.total_due > 0
          ? 0
          : Math.abs(selectPropertyDetail?.total_due);
      if (amount) {
        setInputAmount(Number(amount));
      }
    }
  }, [selectedType, selectPropertyDetail]);

  useEffect(() => {
    if (showForteModal && propertyDetail?.forte_mapping_data) {
      const amount = !isMember
        ? dueAmount
        : Math.abs(leases?.find((lease) => lease?.id === Number(selectedLeaseId))?.available_balance || 0);

      if (amount) {
        setInputAmount(Number(amount));
      }
    }
  }, [showForteModal, isMember, dueAmount, leases, selectedLeaseId, propertyDetail]);

  // Attach global oncallback handle
  useEffect(() => {
    window.oncallback = function (response) {
      console.log("Forte callback received:", response);
      // Parse the data if it's a MessageEvent with a data string
      let parsedData = response;
      if (response.data && typeof response.data === 'string') {
        try {
          parsedData = JSON.parse(response.data);
          console.log("Parsed Forte data:", parsedData);
        } catch (e) {
          console.error("Error parsing Forte data:", e);
        }
      }
      
      // Get event type from the parsed data
      const eventType = parsedData.event;
      if (eventType === "begin") {
        console.log("Forte checkout process started");
        // No need to show a toast or close the modal here
        return; // Exit early, don't process further
      } else if (response.success || eventType === "success") {
        // Successfully initiated transaction
        console.log("Forte success callback full response:", JSON.stringify(response, null, 2));
        // Extract payment details from parsedData
        const paymentId = parsedData.trace_number || parsedData.transaction_id || parsedData.id || "Unknown";
        
        // Get payment amount from parsedData
        let paymentAmount = parseFloat(parsedData.total_amount || 0);
        if (!paymentAmount && inputValues) {
          paymentAmount = parseFloat(inputValues.checkedPayFull ? dueAmount : inputAmount);
        }
        
        // Get category from parsedData
        let categoryName = parsedData.xdata_1 || "Rent";
        
        // Get unit name
        const currentLeaseObj = isMember ? selectedLeaseObj : currentLease;
        
        // Create an optimistic transaction entry
        const optimisticTransaction = {
          id: `temp-${Date.now()}`,
          category: categoryName,
          date: moment().format("YYYY-MM-DD"),  // Use local date in YYYY-MM-DD format
          amount: paymentAmount,
          transaction_type: "CREDIT",
          status: "PENDING",
          unit_name: currentLeaseObj?.unit_name || "All"
        };
        
        // Add to tenantLedger state temporarily
        setTenantLedgerAndProcessing(prev => ({
          ...prev,
          tenantLedger: [optimisticTransaction, ...(prev.tenantLedger || [])]
        }));
        
        // Now close modal and reset values
        setShowForteModal(false);
        resetValues();
        
        toast.success(
          `Processing payment, may take a few minutes to reflect on the ledger. Payment ID: ${paymentId}`
        );
        
        // Keep the existing refresh logic
        const refreshIntervals = [240000, 360000]; // 4m, 6m
        
        refreshIntervals.forEach((interval, index) => {
          setTimeout(() => {
            console.log(`Refreshing ledger data (attempt ${index + 1}) for payment ID: ${paymentId}`);
            getTenantLedger(user?.id, selectedLeaseId || currentLease?.id);
          }, interval);
        });
      } else if (response.abort || eventType === "abort" || eventType === "cancel") {
        // User cancelled the payment
        //  setShowForteModal(false);
         resetValues();
         toast("Payment cancelled. You can update your payment details and try again.");
      } else if (response.failure || eventType === "failure") {
        // Payment processing failure (declined, insufficient funds, etc.)
        toast.error(
          response.response_desc || "We couldn't process your payment. Please try again or contact Arrivo support."
        );
      } else if (response.error || eventType === "error") {
        // Forte validation error
        toast.error(
          response.msg || "We encountered an error processing your payment. Please try again or contact Arrivo support."
        );
      } else {
        // Handle any other unexpected response
        console.warn("Unexpected Forte callback response:", response);
        toast("We couldn't process your payment. Please try again or contact Arrivo support.");
      }
    };

    return () => {
      window.oncallback = undefined;
    };
  }, []);

  const handleClose = () => setAutomaticShow(false);
  const handleCloseScheduledPaymentsSuccess = () => {
    setEditModeAmount("");
    setEditModeDate("");
    setEditModeCategory("");
    setEditModePaymentId("");
    setScheduledPaymentSuccessModal(false);
  };
  /* Prior to Spaces/ Tenant UI/UX Update
  const getDueData = () => {
    let dueDate = "";
    let dueAmount = "";
    const paymentStatusLower = propertyDetail?.status?.toLowerCase();
    const nextDue = formatDate(propertyDetail?.next_due_date);
    const firstDue = formatDate(propertyDetail?.first_due);
    const currentDate = new Date();
    const dueDay = parseInt(propertyDetail?.payment_due_date);
    const dueTime = new Date(`${currentDate.getFullYear()}/${currentDate.getMonth() + 1}/${dueDay}`);

    if (paymentStatusLower === "pastdue" || paymentStatusLower === "due") {
      if (moment(nextDue).valueOf() > currentDate.getTime()) {
        if (dueTime.getTime() < firstDue.valueOf()) {
          dueDate = firstDue;
        } else {
          dueDate = dueTime;
        }
      } else {
        dueDate = nextDue;
      }
    } else {
      let today = moment(currentDate);
      const dateDiff = moment(nextDue).diff(today, "days");
      if (dateDiff <= 7) {
        dueDate = nextDue;
        if (dueTime.getTime() < firstDue.valueOf()) {
          dueAmount = propertyDetail?.first_month_amount_due;
        } else {
          dueAmount = propertyDetail?.rent;
        }
      } else {
        if (paymentStatusLower === "paid") {
          if (dueTime.getTime() < firstDue.valueOf()) {
            dueDate = firstDue;
          } else {
            dueDate = dueTime;
          }
        } else {
          dueDate = nextDue;
        }

        dueAmount = 0;
      }
    }
    const totalAmount = dueAmount + Number(propertyDetail?.total_debit);

    return {
      dueDate: formatDate(dueDate),
      dueAmount: totalAmount < 0 ? Math.abs(totalAmount) : 0,
      avaAmount: Number(propertyDetail?.available_balance) > 0 ? propertyDetail?.available_balance : 0,
    };
  };
*/
  const checkIfWithin = (property) => {
    //check if today is within the lease period
    if (property?.active === 0) {
      return false;
    }
    const currentDate = moment().format("YYYY-MM-DD");
    const startDate = formatDate(property?.lease_start);
    const endDate = formatDate(property?.lease_end);
    const leaseStartDate = moment(startDate).format("YYYY-MM-DD");
    const leaseEndDate = moment(endDate).format("YYYY-MM-DD");
    if (leaseStartDate <= currentDate && leaseEndDate >= currentDate) {
      return true;
    }
    return false;
  };

  const getRelevantLease = (leases) => {
    const currentDate = moment();
    let activeLease = null;
    let nextLease = null;
    let lastLease = null;

    leases?.forEach((lease) => {
      const leaseStartD = formatDate(lease.lease_start);
      const leaseEndD = formatDate(lease.lease_end);
      const leaseStartDate = moment(leaseStartD);
      // Use a direct check on lease.lease_end to decide if moment conversion is necessary
      const leaseEndDate = lease.lease_end ? moment(leaseEndD) : null;

      // Priority 1: Active lease
      if (
        leaseStartDate.isSameOrBefore(currentDate) &&
        (!lease.lease_end || leaseEndDate?.isSameOrAfter(currentDate))
      ) {
        activeLease = lease;
      }

      // Priority 2: Future lease
      if (
        leaseStartDate.isAfter(currentDate) &&
        (!nextLease || leaseStartDate.isBefore(moment(nextLease.lease_start)))
      ) {
        nextLease = lease;
      }

      // Priority 3: Most recent past lease
      if (
        leaseEndDate &&
        leaseEndDate.isBefore(currentDate) &&
        (!lastLease || leaseEndDate.isAfter(moment(lastLease.lease_end)))
      ) {
        lastLease = lease;
      }
    });

    // Determine which lease to return based on the conditions
    const relevantLease = activeLease || nextLease || lastLease;
    return relevantLease ? [relevantLease] : []; // Return in array format
  };

  const getDueData = () => {
    if (isMember) {
      const currentLeases = propertyDetails?.filter((property) => {
        //get all leases that are current
        if (checkIfWithin(property)) {
          return true;
        }
      });

      const earliestNextDueDate =
        currentLeases?.length > 0 &&
        currentLeases?.reduce((prev, curr) => {
          //get the earliest next due date
          return moment(prev?.next_due_date).isBefore(moment(curr?.next_due_date)) ? prev : curr;
        })?.next_due_date;
      return {
        dueDate: formatDate(propertyDetail?.next_due_date),
        dueAmount: parseFloat(
          propertyDetail?.consolidated_balance > 0 ? 0 : Math.abs(propertyDetail?.consolidated_balance)
        ).toFixed(2),
        avaAmount: Number(propertyDetail?.total_due) > 0 ? propertyDetail?.total_due : 0,
      };
    } else {
      return {
        dueDate: formatDate(propertyDetail?.next_due_date),
        dueAmount: parseFloat((propertyDetail?.total_due > 0 ? 0 : Math.abs(propertyDetail?.total_due)).toFixed(2)),
        avaAmount: Number(propertyDetail?.total_due) > 0 ? propertyDetail?.total_due : 0,
      };
    }
  };
  const makePayment = async () => {
    let idempotencyKey = null;
    let paidLeaseId = null;
    try {
      setLoading(true);

      if (inputValues?.checkedPayFull) {
        if (dueAmount > 0) {
          setInputAmount(Number(dueAmount));
        } else {
          toast.error(
            "Your account currently does not require a payment. However, if you'd like to make a payment, simply select the 'Pay Specific Amount' option"
          );
          setLoading(false);
          return;
        }
      }

      const amount = inputValues?.checkedPayFull ? dueAmount : inputAmount;
      const category = tenantCategories?.find((item) => item?.id === Number(selectedType))?.transaction_category_id;
      const categoryName = tenantCategories?.find((item) => item?.id === Number(selectedType))?.category;
      const currentDate = moment(selectedDate).format("YYYY-MM-DD");
      const note =
        categoryName === "Security Deposit"
          ? "Security Deposit"
          : categoryName === "Other"
          ? "Other Payment"
          : `One Time Payment ${currentDate} via Arrivo`;

      if (amount > 10000) {
        setLoading(false);
        return toast.error(
          "This transaction was not processed as the account is not permitted to transfer funds greater than $10,000."
        );
      }
      /*
      if (!selectPropertyDetail) {
        setLoading(false);
        return toast.error(`Please contact your Property Manager for assistance.`);
      }
        */
      const relevantLease = getRelevantLease(leases);
      const selectedResidentLease = relevantLease?.length > 0 ? relevantLease[0] : null;
      const bankAccounts = isMember ? selectedLeaseObj?.bankAccounts : selectedResidentLease?.bankAccounts;

      if (!selectedResidentLease) {
        toast.error("You do not have an active lease");
        setLoading(false);
        return;
      }
      let selectedPMBankAccount = null;

      //if (categoryName === "Security Deposit") {
      selectedPMBankAccount = bankAccounts?.find((item) => item?.collect_deposit === 1);
      /* REMOVED ARRIVO 2954- BECAUSE OF THE NEW PAYMENT FLOW NOT REQUIRIN A BANK ACCOUNT 
        if (!selectedPMBankAccount) {
          toast.error(
            "No deposit bank account found for this lease. Please contact your Property Manager for assistance."
          );
          setLoading(false);
          return;
        }
      } else {
        selectedPMBankAccount = bankAccounts?.find((item) => item?.collect_rent === 1);
        if (!selectedBankAccount) {
          toast.error(
            "No receivables bank account found for this lease. Please contact your Property Manager for assistance."
          );
          setLoading(false);
          return;
        }
      }

      */

      let payload = {
        amount,
        note,
        sender_id: user.id,
        receiver_id: propertyManagerInfo.id,
        bank_account_id: selectedBankAccount?.id || autoPaymentBank?.id,
        portfolio_id: isMember
          ? selectedLeaseObj?.portfolio_id || selectedResidentLease?.portfolio_id
          : selectedResidentLease?.portfolio_id,
        transaction_category_id: category,
        payment_date: moment(selectedDate).format("YYYY-MM-DD"),
        created_by: user.id,
        source: `${envFile.DwOLLA_API_URL}/funding-sources/${
          selectedBankAccount ? selectedBankAccount?.dwolla_funding_id : autoPaymentBank?.dwolla_funding_id
        }`,
      };

      if (inputValues?.checkedPayFull) {
        payload.action = "pay_full_amount";
      } else {
        payload.property_id = isMember ? selectedLeaseObj?.property_id : selectedResidentLease?.property_id;
        payload.property_lease_id = isMember ? selectedLeaseObj?.id : selectedResidentLease?.id;
        payload.property_unit_id = isMember
          ? selectedLeaseObj?.property_unit_id
          : selectedResidentLease?.property_unit_id;
        payload.action = "send_instant_rent";
      }
      paidLeaseId = isMember ? selectedLeaseObj?.id : selectedResidentLease?.id;

      // SUP-1015: one key per tap so a browser resend of this request can't charge the tenant twice
      const submitted = await submitWithIdempotencyKey(payload, {
        send: (data) => API.graphql(graphqlOperation(sendInstantRent, { data })),
        beforeSend: (key) =>
          track(EVENTS.PAYMENT_INITIATED, {
            payment_method: "ach",
            payment_type: inputValues?.checkedPayFull ? "full" : "partial",
            amount: Number(amount),
            category: categoryName,
            lease_id: isMember ? selectedLeaseObj?.id : selectedResidentLease?.id,
            idempotency_key: key,
          }),
      });
      idempotencyKey = submitted.idempotencyKey;
      const res = submitted.res;

      if (res.data.sendInstantRent.status === 200) {
        track(EVENTS.PAYMENT_COMPLETED, {
          payment_method: "ach",
          payment_type: inputValues?.checkedPayFull ? "full" : "partial",
          amount: Number(amount),
          category: categoryName,
          lease_id: isMember ? selectedLeaseObj?.id : selectedResidentLease?.id,
          bank_account_id: selectedBankAccount?.id,
          idempotency_key: idempotencyKey,
        });
        toast.success(
          `${categoryName === "Other " ? "" : "A "} ${
            categoryName ? categoryName : ""
          }   payment was successfully initiated. Review payment progress within the Payment Activity section of the dashboard`
        );
        if (checkTransaction?.length > 0) {
          //setSelectedBankAccount();
          //resetSelectedBankAccount();
          //setAutoPaymentBank();
          getBanksTransaction();
          setPayRentModalShow(false);
          // resetValues(); // ARR-1417: commented this resetValues explicitly out as it was causing an issue with the payment confirmation modal
          //setInputAmount(0);
          const rentCategory = tenantCategories?.find((item) => item?.is_rent === 1);
          setSelectedType(rentCategory?.id || tenantCategories?.[0]?.id || null);
        }
        setEditModeAmount(Number(amount));
        setSubmittedAmount(amount);
        setEditModeDate(moment(selectedDate).format("YYYY-MM-DD"));
        setEditModeCategory(selectedType);
        getTenantLedger(user?.id, isMember ? selectedLeaseObj?.id : selectedResidentLease?.id);
        updateModalShow("paymentConfirmationShow", true);
        resetValues();
        //setScheduledPaymentSuccessModal(true);
      } else {
        track(EVENTS.PAYMENT_FAILED, {
          payment_method: "ach",
          amount: Number(amount),
          reason: res?.data?.sendInstantRent?.response,
          idempotency_key: idempotencyKey,
        });
        toast.error(res?.data?.sendInstantRent?.response);
      }
      setLoading(false);
    } catch (error) {
      // SUP-1015: a lost answer (payment may have gone through) gets the unconfirmed message + history refresh instead of silence
      handlePaymentError(error, {
        track,
        failedEvent: EVENTS.PAYMENT_FAILED,
        notify: (msg) => toast.error(msg),
        refresh: () => {
          getBanksTransaction();
          getTenantLedger(user?.id, paidLeaseId);
        },
      });
      console.log("error", error);
      setLoading(false);
    }
  };

  const schedulePayment = async () => {
    try {
      setLoading(true);
      if (inputValues?.checkedPayFull === true) {
        if (Number(dueAmount) > 0) {
          setInputAmount(Number(dueAmount));
        } else {
          toast.error(
            "Your account currently does not require a payment. However, if you'd like to make a payment, simply select the 'Pay Specific Amount' option"
          );
          setLoading(false);
          return;
        }
      }
      const paymentID = getId();
      const current_date = moment().format("YYYY-MM-DD");
      const category = tenantCategories?.find((item) => item?.id === Number(selectedType))?.transaction_category_id;
      let leasePaymentObj = null;
      const relevantLease = getRelevantLease(leases);
      const selectedResidentLease = relevantLease?.length > 0 ? relevantLease[0] : null;
      const bankAccounts = isMember ? selectedLeaseObj?.bankAccounts : selectedResidentLease?.bankAccounts;

      if (!selectedResidentLease) {
        toast.error("You do not have an active lease");
        setLoading(false);
        return;
      }
      const categoryName = tenantCategories?.find((item) => item?.id === Number(selectedType))?.category;
      let selectedPMBankAccount = null;
      if (categoryName === "Security Deposit") {
        selectedPMBankAccount = bankAccounts?.find((item) => item?.collect_deposit === 1);
        /*
        if (!selectedPMBankAccount) {
          toast.error(
            "No deposit bank account found for this lease. Please contact your Property Manager for assistance."
          );
          setLoading(false);
          return;
        }
          */
      } else {
        selectedPMBankAccount = bankAccounts?.find((item) => item?.collect_rent === 1);
        /*if (!selectedBankAccount) {
          toast.error(
            "No receivables bank account found for this lease. Please contact your Property Manager for assistance."
          );
          setLoading(false);
          return;
        }
        */
      }
      if (isMember) {
        leasePaymentObj = {
          id: getId(),
          property_lease_id: selectedLeaseObj?.id,
          payment_amount: inputValues?.checkedPayFull ? dueAmount : inputAmount,
          payment_type: selectedLeaseObj?.lease_type,
          paymentmethod_id: paymentID,
          late_fee: selectedLeaseObj?.late_fee_amount,
          next_occurance: moment(selectedDate).format("YYYY-MM-DD"),
          actual_last_occurance: current_date,
          time_range: selectedLeaseObj?.grace_period,
          created_by: user?.id,
          active: 1,
          source: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedBankAccount?.dwolla_funding_id}`,
          destination: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedPMBankAccount?.dwolla_funding_resource}`,
          last_modified: moment().utc().format("YYYY-MM-DD HH:MM:SS"),
          created_at: moment().utc().format("YYYY-MM-DD HH:MM:SS"),
          repeat_payment: 0,
          receiverId: propertyManagerInfo.id,
          bank_account_id: selectedBankAccount ? selectedBankAccount?.id : autoPaymentBank?.id,
          receiver_bank_account: selectedPMBankAccount?.bank_account_id,
          payment_category: tenantCategories.find((item) => item?.id === 11)?.id || selectedType, // ARR - 1353 - set default category = common charges for members else whatever was selected
        };
      } else {
        leasePaymentObj = {
          id: getId(),
          property_lease_id: selectedResidentLease?.id,
          payment_amount: inputValues?.checkedPayFull ? dueAmount : inputAmount,
          payment_type: selectedResidentLease?.lease_type,
          paymentmethod_id: paymentID,
          late_fee: selectedResidentLease?.late_fee_amount,
          next_occurance: moment(selectedDate).format("YYYY-MM-DD"),
          actual_last_occurance: current_date,
          time_range: selectedResidentLease?.grace_period,
          created_by: user?.id,
          active: 1,
          source: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedBankAccount?.dwolla_funding_id}`,
          destination: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedPMBankAccount?.dwolla_funding_resource}`,
          last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
          created_at: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
          repeat_payment: 0,
          receiverId: propertyManagerInfo.id,
          bank_account_id: selectedBankAccount ? selectedBankAccount?.id : autoPaymentBank?.id,
          receiver_bank_account: selectedPMBankAccount?.bank_account_id,
          payment_category: selectedType,
        };
      }
      if (leasePaymentObj) {
        const res = await createRecordTB("PropertyLeasePayment", leasePaymentObj);
        if (res) {
          // fixed a reference error observed in console while working on ARR-1353
          const category = res?.payment_category;
          toast.success(
            `${category === "Other" ? "" : "A "} ${
              category ? category : ""
            } payment has been scheduled. Review upcoming payments within the Bank Accounts screen to make changes`
          );
          const amount = res?.payment_amount;
          const date = res?.next_occurance;
          const paymentId = res?.id;
          setEditModeAmount(Number(amount));
          setEditModeDate(moment(selectedDate).format("YYYY-MM-DD"));
          setEditModeCategory(selectedType);
          setEditModePaymentId(paymentId);
          setSubmittedAmount(amount);
          updateModalShow("paymentConfirmationShow", true);
          getUpcomingPayments();
          // resetValues();
          //setScheduledPaymentSuccessModal(true);
        } else {
          toast.error("Something went wrong!");
        }
      }
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handelPayment = async (skipConfirmation = false) => {
    try {
      const selectedPMBankAccounts = leases?.find((lease) => checkIfWithin(lease))?.bankAccounts;
      const hasPMDwollaFundingId = selectedPMBankAccounts?.find((item) => item?.dwolla_funding_resource);
      if (!selectedBankAccount?.dwolla_funding_id) {
        toast.error("Please verify your bank account to process the transaction.");
        setPayRentModalShow(false);
        return;
      }
      if (!hasPMDwollaFundingId) {
        /*
        toast.error("Please contact your Property Manager as we are unable to process your transaction at this time.");
        setPayRentModalShow(false);
        return;
        */
      }
      if (Number(inputAmount) <= 0 && inputValues?.checkedPayPartial) {
        toast.error("Entered amount should be more than 0");
        return;
      }
      const dateDiff = moment(dueDate).diff(moment(selectedDate), "days");
      if (category === "Rent" && dueAmount === 0 && dateDiff >= 7) {
        toast.error("Arrivo will not process early rent payments 7 days before rent is due");
        return;
      }
      if (isMember && !selectedLeaseObj && inputValues?.checkedPayPartial && selectedLeaseObj !== "") {
        toast.error("Please select space id");
        setLoading(false);
        return;
      }
      // setLoading(true);
      if (checkTransaction?.length > 0 && !skipConfirmation) {
        setPayRentModalShow(false);
        track(EVENTS.DUPLICATE_PAYMENT_WARNING_SHOWN, { pending_amount: checkTransaction?.[0]?.amount });
        setConfirmation(true);
      } else {
        console.log("true", moment(selectedDate).isSame(moment()));
        if (moment(selectedDate).isSame(moment(), "day")) {
          await makePayment();
        } else {
          await schedulePayment();
        }
        //setSelectedBankAccount();
        setAutoPaymentBank();
        getBanksTransaction();
        // setLoading(false);
        setPayRentModalShow(false);
        setInputAmount(0);
        const rentCategory = tenantCategories?.find((item) => item?.is_rent === 1);
        setSelectedType(rentCategory?.id || tenantCategories?.[0]?.id || null);
      }
      console.log("Selected Date in handelPayment:", selectedDate);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      alert("Something went wrong");
    }
  };
  const sendCancelAutoPayEmail = async () => {
    try {
      await API.graphql(
        graphqlOperation(crudCommunications, {
          id: user?.id,
          role: "Tenant",
          code: "TENANTDISABLEAUTOPAY",
          data: JSON.stringify({}),
        })
      );
    } catch (err) {
      console.log("\n ERR", err);
    }
  };
  const removeAutomaticPayment = async () => {
    try {
      setLoading(true);
      const isExit = upcomingPayments?.find((item) => item.repeat_payment === 1 || item?.member_auto_payment === 1);
      if (isExit) {
        if (isExit?.member_auto_payment === 1) {
          const memberLeasePaymentObj = {
            id: isExit?.member_auto_payment_id,
            last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
            active: 0,
          };
          await updateRecordTB("MemberAutoPayment", memberLeasePaymentObj);
          await sendCancelAutoPayEmail();
          setDeactivatedAutomaticPaymentModalShow(true);
          setIsDefaultAutomnatic(false);
          getUpcomingPayments();
          getAllBankAccounts();
        } else {
          const propertyLeasePaymentObj = {
            id: isExit?.lease_payment_id,
            repeat_payment: 0,
            active: 0,
            last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
          };
          await updateRecordTB("PropertyLeasePayment", propertyLeasePaymentObj);
          await sendCancelAutoPayEmail();
          setDeactivatedAutomaticPaymentModalShow(true);
          setIsDefaultAutomnatic(false);
          getUpcomingPayments();
          getAllBankAccounts();
        }
        track(EVENTS.AUTOPAY_DISABLED, { lease_id: currentLease?.id });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("cancel auto payment error  ", error);
      toast.error("Something went wrong");
    }
  };
  const groupLeasesByUnit = (leases) => {
    const grouped = leases?.reduce((acc, lease) => {
      // Group leases by property_unit_id
      if (!acc[lease.property_unit_id]) {
        acc[lease.property_unit_id] = [];
      }
      acc[lease.property_unit_id].push(lease);
      return acc;
    }, {});

    const relevantLeases = Object.keys(grouped)?.reduce((acc, propertyUnitId) => {
      // Select the most relevant lease for each property unit ID
      acc[propertyUnitId] = getRelevantLease(grouped[propertyUnitId])[0] || {};
      return acc;
    }, {});
    return relevantLeases;
  };
  useEffect(() => {
    if (!currentLease?.id || currentLease?.pending_autopay_update !== 1) return;
    const autopayRecord = upcomingPayments?.find((p) => p.repeat_payment === 1);
    if (!autopayRecord) {
      dismissAutopayFlag();
      return;
    }
    setPendingAutopayRecord(autopayRecord);
    updateModalShow("rentMismatchModal", true);
  }, [currentLease, upcomingPayments]);

  const dismissAutopayFlag = async () => {
    try {
      await API.graphql(
        graphqlOperation(crudPropertyUnitLease, {
          data: JSON.stringify({
            action: "dismiss_autopay_update",
            property_lease_id: currentLease?.id,
          }),
        })
      );
      // Optimistically clear local state so the modal-trigger effect
      // (keyed on currentLease + upcomingPayments) doesn't re-fire and
      // reopen the modal when getUpcomingPayments() refreshes.
      setCurrentLease((prev) => ({ ...prev, pending_autopay_update: 0 }));
      setPendingAutopayRecord(null);
    } catch (err) {
      console.log("dismissAutopayFlag error:", err);
    }
  };

  const handleAutopayUpdateYes = async () => {
    try {
      setLoading(true);
      await updateRecordTB("PropertyLeasePayment", {
        id: pendingAutopayRecord.lease_payment_id,
        payment_amount: currentLease.rent,
        last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      });
      await dismissAutopayFlag();
      await API.graphql(
        graphqlOperation(crudCommunications, {
          id: user?.id,
          role: "Tenant",
          code: "TENANTAUTOPAYSET",
          data: JSON.stringify({
            payment_amount: currentLease.rent,
            next_occurance: pendingAutopayRecord.next_occurance,
          }),
        })
      );
      getUpcomingPayments();
      updateModalShow("rentMismatchModal", false);
      track(EVENTS.AUTOPAY_UPDATED, { lease_id: currentLease?.id, amount: currentLease?.rent });
      toast.success("Autopay updated successfully!");
    } catch (err) {
      console.log("handleAutopayUpdateYes error:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAutopayUpdateNo = async () => {
    track(EVENTS.AUTOPAY_MISMATCH_DISMISSED, { lease_id: currentLease?.id });
    await dismissAutopayFlag();
    updateModalShow("rentMismatchModal", false);
  };

  const handleAutopayUpdateCancel = async () => {
    await removeAutomaticPayment();
    await dismissAutopayFlag();
    updateModalShow("rentMismatchModal", false);
  };

  const automaticPayment = async (specificDate = null, specificAmount = null) => {
    try {
      const relevantLease = getRelevantLease(leases);
      const selectedActiveLease = relevantLease?.length > 0 ? relevantLease[0] : null;
      const bankAccounts = selectedActiveLease?.bankAccounts;
      if (!selectedActiveLease) {
        toast.error("You do not have an active lease");
        setLoading(false);
        return;
      }
      let selectedPMBankAccount = bankAccounts?.find((item) => item?.collect_rent === 1);

      if (!selectedBankAccount?.dwolla_funding_id) {
        toast.error("Please verify your bank account to process the transaction.");
        handleClose();
        return;
      }
      /*
      if (!selectedPMBankAccount?.dwolla_funding_resource) {
        toast.error("Please contact your Property Manager as we are unable to process your transaction at this time.");
        handleClose();
        return;
      }
*/
      setLoading(true);
      const paymentID = getId();
      const current_date = moment().format("YYYY-MM-DD");
      const future_date = moment(current_date).add(1, "M").format("YYYY-MM");
      const next_occurance = moment(future_date)
        .add(parseInt(selectedActiveLease?.payment_due_date) - 1, "days")
        .format("YYYY-MM-DD");

      const isExit = upcomingPayments?.find((item) => item.repeat_payment === 1);
      if (isExit) {
        const bankAccountObj = {
          id: isExit?.id,
          repeat_payment: 1,
          active: 0,
          payment_category: 2,
        };
        await updateRecordTB("PropertyLeasePayment", bankAccountObj);
        getAllBankAccounts();
        getUpcomingPayments();
      } else {
        if (isMember) {
          const leasePaymentObj = {
            action: "member_auto_payment",
            bank_account_id: selectedBankAccount?.id,
            tenant_id: user?.id,
            payment_date: moment(specificDate).format("YYYY-MM-DD"),
            created_by: user?.id,
          };
          const res = await API.graphql(graphqlOperation(sendInstantRent, { data: JSON.stringify(leasePaymentObj) }));
          if (res?.data?.sendInstantRent?.status === 200) {
            track(EVENTS.AUTOPAY_ENABLED, { bank_account_id: leasePaymentObj?.bank_account_id });
            toast.success(
              `Autopay scheduled successfully, your first payment is set for ${moment(
                specificDate ? specificDate : next_occurance
              ).format("MMMM Do")}!`
            );
            //setSubmittedAutomaticPaymentAmount(specificAmount ? specificAmount : selectedActiveLease?.rent);
            //setSubmittedAutomaticPaymentDate(specificDate ? specificDate : next_occurance);
          } else {
            toast.error(res?.data?.sendInstantRent?.response || "Something went wrong");
          }
        } else {
          const leasePaymentObj = {
            id: getId(),
            property_lease_id: selectedActiveLease?.id,
            payment_amount: specificAmount ? specificAmount : selectedActiveLease?.rent,
            payment_type: selectedActiveLease?.lease_type,
            paymentmethod_id: paymentID,
            late_fee: selectedActiveLease?.late_fee_amount,
            next_occurance: specificDate ? specificDate : next_occurance,
            actual_last_occurance: current_date,
            time_range: selectedActiveLease?.grace_period,
            created_by: user?.id,
            active: 1,
            source: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedBankAccount?.dwolla_funding_id}`,
            destination: `${envFile.DwOLLA_API_URL}/funding-sources/${selectedPMBankAccount?.dwolla_funding_resource}`,
            last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
            created_at: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
            repeat_payment: 1,
            receiverId: propertyManagerInfo.id,
            bank_account_id: selectedBankAccount?.id,
            receiver_bank_account: selectedPMBankAccount?.bank_account_id,
            payment_category: 2,
          };
          const res = await createRecordTB("PropertyLeasePayment", leasePaymentObj);
          if (res?.id) {
            track(EVENTS.AUTOPAY_ENABLED, {
              bank_account_id: leasePaymentObj?.bank_account_id,
              lease_id: leasePaymentObj?.property_lease_id,
            });
            toast.success(
              `Autopay scheduled successfully, your first payment is set for ${moment(
                specificDate ? specificDate : next_occurance
              ).format("MMMM Do")}!`
            );
            setSubmittedAutomaticPaymentAmount(specificAmount ? specificAmount : selectedActiveLease?.rent);
            setSubmittedAutomaticPaymentDate(specificDate ? specificDate : next_occurance);
            updateModalShow("automaticPaymentConfirmationShow", true);
            await API.graphql(
              graphqlOperation(crudCommunications, {
                id: user?.id,
                role: "Tenant",
                code: "TENANTAUTOPAYSET",
                data: JSON.stringify({
                  payment_amount: specificAmount ? specificAmount : selectedActiveLease?.rent,
                  next_occurance: specificDate ? specificDate : next_occurance,
                }),
              })
            );
          }
        }
        /*
        API => sendInstantRent
        action: "member_auto_payment",
        bank_account_id: selected by tenant
        tenant_id: tenent id
        payment_date: ("YYYY-MM-DD"),
        created_by: logged in tenant
       */
      }
      //setSelectedBankAccount();
      resetValues();
      getAllBankAccounts();
      getUpcomingPayments();
      setLoading(false);
      handleClose();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const paymentStatus = propertyDetail?.status;

  const handleEditSuccessfulPayment = async () => {
    //cannot edit instant payment because it instantly created tenant ledger record
    if (moment(selectedDate).isSame(moment(), "day")) {
      toast.error(
        "This action cannot be completed as the payment is currently in progress. Please contact your property manager if you have questions."
      );
      return;
    } else {
      setSuccessfulPaymentScreenEditMode(!successfulPaymentScreenEditMode);
    }
  };

  const modalToggler = (modalName) => (isVisible) => {
    updateModalShow(modalName, isVisible);
  };

  const resetSelectedBankAccount = () => {
    const defaultBankAccount = bankAccounts?.find((item) => item?.default_bank_account === 1)
      ? bankAccounts?.find((item) => item?.default_bank_account === 1)
      : null;
    if (defaultBankAccount) {
      setSelectedBankAccount(defaultBankAccount);
    } else {
      setSelectedBankAccount();
    }
  };
  const handleSaveEditPayment = async () => {
    try {
      setLoading(true);
      if (Number(editModeAmount) <= 0 || isNaN(editModeAmount)) {
        toast.error("Entered amount should be more than 0");
        setLoading(false);
        return;
      }
      if (successfulPaymentScreenEditMode) {
        const bankAccountObj = {
          id: editModePaymentId,
          payment_amount: editModeAmount,
          next_occurance: moment(editModeDate).format("YYYY-MM-DD"),
          last_modified: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
          //bank_account_id: scheduledPayment?.bank_account_id,
          payment_category: editModeCategory,
        };
        const res = await updateRecordTB("PropertyLeasePayment", bankAccountObj);
        if (res?.id) {
          toast.success("Payment updated successfully!");
          const amount = res?.payment_amount;
          const date = res?.next_occurance;
          const category = res?.payment_category;
          const paymentId = res?.id;
          const formattedDate = moment(editModeDate).format("YYYY-MM-DD");
          setEditModeAmount(Number(amount));
          setEditModeDate(formattedDate);
          setEditModeCategory(category);
          setEditModePaymentId(paymentId);
        } else {
          toast.error("Something went wrong!");
        }
        setSuccessfulPaymentScreenEditMode(false);
        setLoading(false);
      } else {
        setScheduledPaymentSuccessModal(false);
        setLoading(false);
      }

      return;
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const DueCard = () => {
    // Guard: Wait for forte_mapping_data to be loaded before rendering Forte button
    if (typeof propertyDetail?.forte_mapping_data === "undefined") {
      return (
        <Card className="pt-0">
          <Card.Body>
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
              <SpinnerLoading />
            </div>
          </Card.Body>
        </Card>
      );
    }
    return (
      <>
        <Card className={`${isPastDue ? "red-border" : ""} pt-0`}>
          <Card.Body>
            {payabliLoading && (
              <div className="loadingSpinner">
                <SpinnerLoading />
              </div>
            )}
            <Row className="payment-due">
              <Col lg={12}>
                <Row className="mb-lg-0 mb-2 align-items-center total-due">
                  <Col lg={12} className="d-md-none red-text mb-2" style={{ fontSize: "22px" }}>
                    {isPastDue ? "Past Due" : ""}
                  </Col>
                  <Col xl={propertyDetail?.forte_mapping_data ? 7 : 12} lg={12}>
                    <h4 className="due-amount-title p-1">Your Current Balance</h4>
                    {/* SHOW EXAMPLE BADGE TO THE RIGHT */}
                    {tenantLedger?.filter((item) => item?.status === "PENDING").length > 0 && (
                      <div className="payment-status badge bg-yellow" style={{ width: "125px" }}>
                        Payment Pending
                      </div>
                    )}
                    <div className="d-flex justify-content-end justify-content-lg-start flex-lg-row flex-column">
                      <span className={`due-amount-text ${isPastDue ? "red-text" : ""}`}>
                        {dueAmount > 0 ? formatUSNumber(dueAmount) : "-"}
                      </span>
                    </div>
                    {/* Add Past Due status for desktop view */}
                    {/*
                    {isPastDue && (
                      <div className="d-none d-md-block red-text" style={{ fontSize: "18px", marginTop: "10px" }}>
                        Past Due
                      </div>
                    )}
                    */}
                    <h4 className="card-title mt-4" style={{ fontSize: "16px" }}>
                      {propertyDetail?.upcoming_due_date ? (
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                          <span>Payment due on&nbsp;</span>
                          <span>{moment(formatDate(propertyDetail.upcoming_due_date)).format("MMMM Do, YYYY")}</span>
                        </div>
                      ) : (
                        "There is nothing for you to pay"
                      )}
                    </h4>
                  </Col>
                  {/* Add button column for Forte flow as a separate column */}
                  {propertyDetail?.forte_mapping_data && (
                    <Col xl={5} lg={12} className="d-flex align-items-center justify-content-lg-end mt-4 mt-xl-0">
                      <div style={{ width: "100%", maxWidth: "400px" }} className="w-100">
                        <button
                          type="button"
                          className="btn-primary w-100"
                          data-cy="makepayment"
                          style={{
                            width: "100%",
                            maxWidth: "100%",
                          }}
                          onClick={() => {
                            if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                              toast.error("Please contact your Property Manager for assistance.");
                            } else {
                              setSelectedDate(new Date());
                              resetValues();
                              setShowForteModal(true);
                            }
                          }}
                        >
                          Pay Now ($ CAN)
                        </button>
                        <div className="text-center mt-2" style={{ fontSize: "14px", color: "gray" }}>
                          Processed by Forte Payment Systems
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col
                    lg={propertyDetail?.forte_mapping_data ? 0 : 2}
                    className={`d-flex justify-content-start align-items-start red-text mt-4 mb-4 mt-lg-2 past-due-text d-none d-md-block ${
                      propertyDetail?.forte_mapping_data ? "d-lg-none" : ""
                    }`}
                  >
                    {isPastDue ? "Past Due" : ""}
                  </Col>
                  {/* START Desktop View for DUEAMOUNT/DUEDATE */}
                </Row>
              </Col>
              <Row className="d-flex p-0 m-0 g-0">
                {propertyDetail?.forte_mapping_data ? (
                  <></> // Empty fragment since we've moved the button to the balance info row
                ) : (
                  <>
                    {/* Original three buttons */}
                    <Col xxl={4} xl={12} md={12} className="mt-3 p-0 px-1 d-flex flex-column">
                      <button
                        type="button"
                        className="btn-primary btn-pay-methods w-100"
                        data-cy="makepayment"
                        onClick={() => {
                          if (user?.dwolla_customer_id) {
                            if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                              toast.error("Please contact your Property Manager for assistance.");
                            } else {
                              //if hoa dues, set category to hoa dues, if is member, set category to common charges, else set category to rent
                              const isHOA = propertyDetail?.property_type === "HOA";
                              const hoaDuesCategory = tenantCategories?.find((item) => item?.id === 21);
                              const commonChargesCategory = tenantCategories?.find((item) => item?.id === 11);
                              const rentCategory = tenantCategories?.find((item) => item?.is_rent === 1);
                              setSelectedType(
                                isHOA
                                  ? hoaDuesCategory?.id
                                  : user?.is_member === 1
                                  ? commonChargesCategory?.id
                                  : rentCategory?.id
                              );
                              updateModalShow("paymentMethodSelectionShow", true);
                              if (dueAmount === 0) {
                                setInputValues({ ...inputValues, checkedPayFull: false, checkedPayPartial: true });
                              }
                            }
                          } else {
                            toast.error("Please add bank account.");
                            navigate("/BankAccount");
                          }
                        }}
                        style={{
                          fontSize: "14px", // Smaller font size
                          textAlign: "center", // Center the text
                          whiteSpace: "nowrap", // Prevent text from wrapping
                          float: "left", // Float the button to the left
                          marginRight: "10px",
                        }}
                      >
                        Pay Now via ACH Transfer
                      </button>
                      <label className="d-flex justify-content-center mt-2" style={{ color: "gray", fontSize: "14px" }}>
                        All ACH Transfers are FREE
                      </label>
                    </Col>

                    <Col xl={12} xxl={4} className="mt-3 p-0 px-1 d-flex flex-column">
                      <button
                        type="button"
                        className="btn-secondary btn-pay-methods w-100 mx-0 mx-xl-3"
                        data-cy="makepayment"
                        onClick={() => {
                          if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                            toast.error("Please contact your Property Manager for assistance.");
                          } else {
                            track(EVENTS.PAYMENT_INITIATED, {
                              payment_method: "credit_card",
                              lease_id: selectedLeaseObj?.id,
                            });
                            updateModalShow("creditCardPaymentShow", true);
                          }
                        }}
                        style={{
                          fontSize: "14px", // Smaller font size
                          textAlign: "center", // Center the text
                          whiteSpace: "nowrap", // Prevent text from wrapping
                          float: "left", // Float the button to the left
                          marginRight: "10px",
                        }}
                        disabled={!propertyDetail?.subdomain || !propertyDetail?.paypoint_id}
                      >
                        Pay Now with Credit Card
                      </button>
                      <label
                        className="d-flex justify-content-center mt-2 p-0"
                        style={{ color: "gray", fontSize: "14px" }}
                      >
                        2.9% + $0.30 per Transaction
                      </label>
                    </Col>

                    <Col xl={12} xxl={4} className="mt-3">
                      <button
                        type="btn-pay-methods"
                        className={`w-100 btn ${isDefaultAutomatic ? "btn-inverse-3" : "btn-inverse-2"} mx-0 mx-xl-2 `}
                        style={{ height: "50px" }}
                        data-cy="makepayment"
                        onClick={() => {
                          if (user?.dwolla_customer_id) {
                            if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                              toast.error("Please contact your Property Manager for assistance.");
                            } else {
                              if (isDefaultAutomatic) {
                                removeAutomaticPayment();
                              } else {
                                setAutomaticShow(true);
                              }
                            }
                          } else {
                            toast.error("Please add bank account.");
                            navigate("/BankAccount");
                          }
                        }}
                      >
                        {isDefaultAutomatic ? "Cancel Autopay" : "Set Up Autopay"}
                      </button>
                    </Col>
                  </>
                )}
              </Row>

              <Row className="mt-4 d-flex justify-content-between m-0 p-0">
                <Col lg={6} className="autotogglesm">
                  {/*!isMember && (
                  <div className="form-switch d-flex" style={{ marginLeft: "30px" }}>
                    <div className="d-flex">
                      Automatic Payment
                      <button
                        type="button"
                        className="btn btn-pop"
                        data-bs-container="body"
                        data-bs-toggle="popover"
                        data-bs-placement="bottom"
                        data-bs-content="Payments will be withdrawn each month on your due date (if your due date falls on a Saturday, we'll make your payment on the Friday before)."
                      >
                        <img src={require("../../../assets/images/help.svg").default} alt="" />
                        <div className="popHover">
                          <p>
                            Payments will be withdrawn each month on your due date (if your due date falls on a
                            Saturday, we'll make your payment on the Friday before).
                          </p>
                        </div>
                      </button>
                    </div>
                    <form>
                      <input
                        type="checkbox"
                        hidden="hidden"
                        id="autopayment"
                        onChange={(e) => {
                          if (user?.dwolla_customer_id) {
                            if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                              toast.error("Please contact your Property Manager for assistance.");
                            } else {
                              if (e.target.checked) {
                                setAutomaticShow(e.target.checked);
                              } else {
                                removeAutomaticPayment();
                              }
                            }
                          } else {
                            toast.error("Please add bank account.");
                            navigate("/BankAccount");
                          }
                        }}
                        checked={isDefaultAutomatic}
                      />
                      <label className="switch" htmlFor="autopayment" />
                    </form>
                  </div>
                )*/}
                </Col>

                <Col lg={6} sm={12}>
                  {/*
                <div className="d-flex justify-content-end">
                  <div className="text-right primary-text" style={{ cursor: "pointer", fontSize: "16px" }}>
                    <strong
                      style={{ marginLeft: "15px" }}
                      className="ml-4"
                      onClick={() => {
                        handleViewScheduledPayments();
                      }}
                    >
                      View Scheduled Payments
                    </strong>
                  </div>
                </div>
                    */}
                </Col>
              </Row>
            </Row>
            <div className="payment-details">
              <Row>
                <Col xl={8} md={7}>
                  <Row>
                    <div className="col-6 col-lg-12 "></div>
                  </Row>
                </Col>
                <Col sm={12} className="text-start autotogglelg d-md-none">
                  {/*!isMember && (
                  <div className="form-switch d-flex justify-content-between justify-content-lg-end">
                    <div className="d-flex align-items-center" style={{ marginLeft: "35px" }}>
                      Automatic Payment
                      <button
                        type="button"
                        className="btn btn-pop"
                        data-bs-container="body"
                        data-bs-toggle="popover"
                        data-bs-placement="bottom"
                        data-bs-content="Payments will be withdrawn each month on your due date (if your due date falls on a Saturday, we'll make your payment on the Friday before)."
                      >
                        <img src={require("../../../assets/images/help.svg").default} alt="" />
                        <div className="popHover">
                          <p>
                            Payments will be withdrawn each month on your due date (if your due date falls on a
                            Saturday, we'll make your payment on the Friday before).
                          </p>
                        </div>
                      </button>
                    </div>
                    <form>
                      <input
                        type="checkbox"
                        hidden="hidden"
                        id="autopayment"
                        onChange={(e) => {
                          if (user?.dwolla_customer_id) {
                            if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                              toast.error("Please contact your Property Manager for assistance.");
                            } else {
                              if (e.target.checked) {
                                setAutomaticShow(e.target.checked);
                              } else {
                                removeAutomaticPayment();
                                setDeactivatedAutomaticPaymentModalShow(true);
                              }
                            }
                          } else {
                            toast.error("Please add bank account.");
                            navigate("/BankAccount");
                          }
                        }}
                        checked={isDefaultAutomatic}
                      />
                      <label className="switch" htmlFor="autopayment" />
                    </form>
                  </div>
                )*/}
                </Col>{" "}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  };

  const PaymentsDueHistory = () => {
    return (
      <Card>
        <div className="d-flex align-items-center mb-3 p-4">
          <div className="flex-grow-1">
            <h4 className="card-title" style={{ marginLeft: "9px" }}>
              Payments Due
            </h4>
          </div>
        </div>
        <div className="table-responsive" data-simplebar style={{ maxHeight: "125px" }}>
          <table className="table document-list" style={{ marginLeft: "30px" }}>
            <thead>
              <tr>
                <th>{isMember ? "Space ID" : "Unit Name"}</th>
                <th>Category</th>
                <th>Amount</th>
                <th>Due Date</th>
                {/*<th>Action</th>*/}
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {propertyDetail?.security_deposit_date !== null && propertyDetail?.security_deposit_amount < 0 && (
                <tr key={"security"}>
                  <td>{propertyDetail?.property_unit_name}</td>
                  <td>Security Deposit</td>
                  <td>${Math.abs(propertyDetail?.security_deposit_amount)}</td>
                  <td>{formatDate(propertyDetail?.security_deposit_date) || ""}</td>
                </tr>
              )}
              {/*
              If rent does not exist in paymentsDue and there is an upcoming due date then that means this is a new lease and should show the first charge
              */}
              {propertyDetail?.upcoming_due_date &&
                propertyDetail?.rent_due_amount &&
                !paymentsDue?.find((item) => item?.category === "Rent") && (
                  <tr key={"rent"}>
                    <td>{propertyDetail?.property_unit_name}</td>
                    <td>Rent</td>
                    <td>${Math.abs(propertyDetail?.rent_due_amount)}</td>
                    <td>{formatDate(propertyDetail?.upcoming_due_date) || ""}</td>
                  </tr>
                )}
              {paymentsDue?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item?.unit_name}</td>
                    {/* Current APIs only return Rent from tpLeasePayments*/}
                    <td>{item?.category}</td>
                    <td>${item?.amount}</td>
                    <td>{formatDate(item?.due_date) || ""}</td>
                    {/*<td>
                    <span
                      target="_blank"
                      className="primary-text"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (!selectPropertyDetail) {
                          toast.error("Please contact your Property Manager for assistance.");
                          return;
                        }
                        if (user?.dwolla_customer_id) {
                          if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                            toast.error("Please contact your Property Manager for assistance.");
                          } else {
                            setInputAmount(item?.rent);
                            setPayRentModalShow(true);
                          }
                        } else {
                          toast.error("Please add bank account.");
                          navigate("/BankAccount");
                        }
                      }}
                    >
                      Pay
                    </span>
                  </td>
                    */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    );
  };
  const TransactionsHistory = () => {
    return (
      <>
        <div className="d-none d-md-block">
          {" "}
          {/* Display table only on medium and larger screens */}
          <Card>
            <div className="d-flex align-items-center mb-3 p-1 mx-4">
              <div className="flex-grow-1">
                <h4 className="card-title transaction-history-label" style={{ marginLeft: "9px" }}>
                  Transaction History
                </h4>
              </div>
            </div>
            <div
              className="table-responsive transaction-table-overflow"
              data-simplebar
              style={{ minHeight: "200px", maxHeight: "225px" }}
            >
              <table className="table document-list" style={{ marginLeft: "30px" }}>
                <thead>
                  <tr>
                    {isMember && <th>Space ID</th>}
                    <th>Category</th>
                    <th>Date</th>
                    <th>Charge</th>
                    <th>Payment</th>
                    <th>Balance</th>
                    {/*<th>Action</th>*/}
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {/*
              If rent does not exist in paymentsDue and there is an upcoming due date then that means this is a new lease and should show the first charge
              */}
              {/* // Changed from:
                  {[...tenantLedgerAndProcessing?.scheduled, ...tenantLedgerAndProcessing?.tenantLedger].map(
                  (item, index) => { 
              */}
                  {[...tenantLedgerAndProcessing?.scheduled, ...tenantLedgerAndProcessing?.tenantLedger]
                    .sort((a, b) => {
                      // Parse dates for comparison
                      const dateA = new Date(a.date);
                      const dateB = new Date(b.date);
                      // Sort descending (newest first) - Aug 1 then July 27 then July 25, etc.
                      return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
                    })
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          {/* Current APIs only return Rent from tpLeasePayments*/}
                          {isMember && (
                            <td style={{ minWidth: "50px" }} className={`${item?.status !== "COMPLETED" ? "" : ""}`}>
                              {item?.unit_name || "All"}
                            </td>
                          )}
                          <td style={{ minWidth: "140px" }}>
                            {item?.category && item.category.length > 15
                              ? item.category.substring(0, 15) + "..."
                              : item?.category}

                            {item?.payabli_reference_id && item?.transaction_type === "CREDIT" && (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id={`tooltip-top`}>Payabli Credit Card Payment</Tooltip>}
                              >
                                <img
                                  className="mx-1"
                                  src={require("../../../assets/images/credit-card.svg").default}
                                  alt=""
                                />
                              </OverlayTrigger>
                            )}
                          </td>

                          <td className={`${item?.status !== "COMPLETED" ? "" : ""}`}>
                            {formatDate(item?.date) || ""}
                          </td>
                          <td className="text-danger">
                            {item?.member_auto_payment !== 1 &&
                              (item?.transaction_type === "DEBIT"
                                ? item?.amount !== null
                                  ? `$${numberWithCommas(item?.amount)}`
                                  : "-"
                                : "")}
                          </td>
                          <td className="primary-text">
                            {item?.member_auto_payment === 1
                              ? "Full Balance"
                              : item?.transaction_type === "CREDIT"
                              ? item?.amount !== null
                                ? `$${numberWithCommas(item?.amount)}`
                                : "-"
                              : ""}
                          </td>
                          <td>
                            {item?.status === "FAILED" ? (
                              <span
                                style={{
                                  color: "#FF0000",
                                }}
                              >
                                <i>Failed</i>
                              </span>
                            ) : item?.status === "CANCELLED" ? (
                              <span
                                style={{
                                  color: "#FF0000",
                                }}
                              >
                                <i>Cancelled</i>
                              </span>
                            ) : item?.status === "COMPLETED" ? (
                              `$${numberWithCommas(isMember ? item?.consolidated_balance * -1 : item?.balance * -1)}`
                            ) : item?.status === "AUTOMATIC" || item?.member_auto_payment === 1 ? (
                              <span
                                style={{
                                  color: "#539488",
                                  border: "2px solid #539488",
                                  padding: "5px",
                                  borderRadius: "10px",
                                }}
                              >
                                Scheduled Autopay
                              </span>
                            ) : item?.status === "SCHEDULED" ? (
                              <span
                                style={{
                                  color: "#CCCCCC",
                                }}
                              >
                                <i>Scheduled Payment</i>
                              </span>
                            ) : item?.status === "PENDING" ? (
                              <span
                                style={{
                                  color: "#CCCCCC",
                                }}
                              >
                                <i>Pending Payment</i>
                              </span>
                            ) : null}
                          </td>

                          {/*<td>
                    <span
                      target="_blank"
                      className="primary-text"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (!selectPropertyDetail) {
                          toast.error("Please contact your Property Manager for assistance.");
                          return;
                        }
                        if (user?.dwolla_customer_id) {
                          if (["SUSPENDED", "DEACTIVATED"].includes(user?.status)) {
                            toast.error("Please contact your Property Manager for assistance.");
                          } else {
                            setInputAmount(item?.rent);
                            setPayRentModalShow(true);
                          }
                        } else {
                          toast.error("Please add bank account.");
                          navigate("/BankAccount");
                        }
                      }}
                    >
                      Pay
                    </span>
                  </td>
                    */}
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
            <hr />
            <div className="d-flex align-items-center p-3 mb-1" style={{ padding: "0 20px" }}>
              <div className="flex-grow-1 fw-bold d-flex justify-content-between" style={{ margin: "0 10px" }}>
                <span style={{ marginTop: "0px", fontSize: "16px" }}>Total Balance</span>
                <span style={{ marginRight: "19px" }}>{dueAmount > 0 ? formatUSNumber(dueAmount) : "-"}</span>
              </div>
            </div>
          </Card>
        </div>
        <div className="d-md-none">
          {" "}
          <div className="dashboard-mob-view d-lg-none">
            {/* ADD RENTERS INSURANCE */}
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingRentersInsurance">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseRentersInsurance"
                  aria-expanded="false"
                  aria-controls="collapseRentersInsurance"
                  style={{
                    borderColor: "#9BD5C3",
                    borderWidth: "2px", // Adjust the width as needed
                    borderStyle: "solid",
                    borderRadius: "15px",
                  }}
                >
                  <span className="title" style={{ color: "#9BD5C3" }}>
                    {isMember ? "Home Warranty" : "Renters Insurance"}
                  </span>
                </button>
              </h3>
              <div
                id="collapseRentersInsurance"
                className="accordion-collapse collapse"
                aria-labelledby="headingRenterInsurance"
                data-bs-parent="#accordionExample"
              >
                <RentersInsurance isMember={isMember} tenantWidgets={tenantWidgets} />
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingTransactionHistory">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTransactionHistory"
                  aria-expanded="false"
                  aria-controls="collapseTransactionHistory"
                >
                  <span className="title">{"Transaction History"}</span>
                </button>
              </h3>
              <div
                id="collapseTransactionHistory"
                className="accordion-collapse collapse"
                aria-labelledby="headingTransactionHistory"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {/* Display card view only on small screens */}
                  {/* 
                  // Changed from:
                  {[...tenantLedgerAndProcessing?.scheduled, ...tenantLedgerAndProcessing?.tenantLedger]
                    ?.slice(0, 9)
                    .map((item, index) => (
                  */}
                  {[...tenantLedgerAndProcessing?.scheduled, ...tenantLedgerAndProcessing?.tenantLedger]
                    .sort((a, b) => {
                      // Parse dates for comparison
                      const dateA = new Date(a.date);
                      const dateB = new Date(b.date);
                      // Sort descending (newest first) - Aug 1 then July 27 then July 25, etc.
                      return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
                    })
                    ?.slice(0, 9)
                    .map((item, index) => (
                      <Card key={index}>
                        <Card.Body>
                          {isMember && (
                            <p className={`${item?.status !== "COMPLETED" ? "" : ""}`}>
                              <strong>Space ID:</strong> {item?.unit_name || "All"}
                            </p>
                          )}
                          <p>
                            <strong>Category:</strong>{" "}
                            {item?.category && item.category.length > 15
                              ? item.category.substring(0, 15) + "..."
                              : item?.category}
                            {item?.status !== "COMPLETED" && (
                              <span className={`${statusStyles(item?.status)?.styles} mx-4`} style={{ float: "right" }}>
                                {statusStyles(item?.status)?.text}
                              </span>
                            )}
                          </p>

                          <p className={`${item?.status !== "COMPLETED" ? "" : ""}`}>
                            <strong>Date:</strong> {formatDate(item?.date) || ""}
                          </p>
                          <p className="text-danger">
                            <strong>Charge:</strong>{" "}
                            {item?.member_auto_payment !== 1 && item?.transaction_type === "DEBIT"
                              ? item?.amount !== null
                                ? `$${numberWithCommas(item?.amount)}`
                                : "-"
                              : ""}
                          </p>
                          <p className="primary-text">
                            <strong>Payment:</strong>{" "}
                            {item?.member_auto_payment === 1
                              ? "Full Balance"
                              : item?.transaction_type === "CREDIT"
                              ? item?.amount !== null
                                ? `$${numberWithCommas(item?.amount)}`
                                : "-"
                              : ""}
                          </p>
                          <hr />
                          <p>
                            {item?.status === "COMPLETED" ? (
                              <>
                                <strong>Balance:</strong> $
                                {numberWithCommas(isMember ? item?.consolidated_balance * -1 : item?.balance * -1)}
                              </>
                            ) : item?.status === "AUTOMATIC" || item?.member_auto_payment === 1 ? (
                              <span style={{ color: "#CCCCCC" }}>
                                <i>Scheduled Autopay</i>
                              </span>
                            ) : item?.status === "SCHEDULED" ? (
                              <span style={{ color: "#CCCCCC" }}>
                                <i>Scheduled Payment</i>
                              </span>
                            ) : item?.status === "PENDING" ? (
                              <span style={{ color: "#CCCCCC" }}>
                                <i>Pending Payment</i>
                              </span>
                            ) : null}
                          </p>
                        </Card.Body>
                      </Card>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const BalanceCard = () => {
    return (
      <>
        <DueCard />
        <TransactionsHistory />
        <DocumentsListCard />
      </>
    );
  };
  const DocumentsListCard = () => {
    return (
      <div className="card-body block d-none d-lg-block card p-4">
        <div className="p-0">
          <div className="d-flex align-items-center mb-3">
            <div className="flex-grow-1">
              <h4 className="card-title">Your Documents List</h4>
            </div>
          </div>
          <div>
            <DocumentList deleteDocument={deleteDocument} />
            <div className="uploadDocuments">
              <MyDropzone
                propertyDetail={
                  leases?.find((lease) => checkIfWithin(lease)) || (leases?.length > 0 ? leases[0] : null)
                }
                setLoading={setLoading}
                fetchAllPropertyUnitDocs={fetchAllPropertyUnitDocs}
                text="+ Upload Documents"
                removeBorder={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const getMemberAccountBalance = () => {
    if (inputValues?.checkedPayFull) {
      const amount = dueAmount > 0 ? formatUSNumber(dueAmount) : "-";
      return amount;
    } else {
      const amount =
        leases?.find((lease) => lease?.id === Number(selectedLeaseId))?.available_balance < 0
          ? formatUSNumber(Math.abs(leases?.find((lease) => lease?.id === Number(selectedLeaseId))?.available_balance))
          : "$0";
      return amount;
    }
  };

  const beginCreditCardPayment = () => {
    window.open(`${envFile.PAYABLI_PAYPAGE_API_LINK}/${propertyDetail?.paypoint_id}/${propertyDetail?.subdomain}`);
  };

  // Helper function to wait for ForteCheckout to be available
  const waitForForteCheckout = async () => {
    console.log("Checking for ForteCheckout availability");
    const maxAttempts = 10; // Increase max attempts
    const delayMs = 300; // Slightly longer delay between checks

    for (let i = 0; i < maxAttempts; i++) {
      if (window.ForteCheckout) {
        console.log("ForteCheckout found after", i, "attempts");
        return true;
      }
      console.log(`Waiting for ForteCheckout (attempt ${i + 1}/${maxAttempts})`);
      await new Promise((res) => setTimeout(res, delayMs));
    }

    // ForteCheckout never initialized
    console.error("ForteCheckout not available after", maxAttempts, "attempts");
    throw new Error("ForteCheckout never initialized");
  };

  // Get signed parameters from backend and launch Forte checkout modal
  const getSignedParamsAndLaunch = async () => {
    console.log("getSignedParamsAndLaunch called");
    try {
      const rawAmount = inputValues?.checkedPayFull ? dueAmount : inputAmount;
      const parsedAmount = parseFloat(rawAmount);
      const amount = parsedAmount.toFixed(2);

      console.log("Debug values:", { 
        checkedPayFull: inputValues?.checkedPayFull, 
        dueAmount, 
        inputAmount, 
        rawAmount 
      })

      // Check for invalid input (empty, NaN)
      if (isNaN(parsedAmount)) {
        toast.error("Please enter a valid payment amount");
        return;
      }

      /*
      // Separate check for negative/zero amounts
      if (parsedAmount <= 0) {
        toast.error("Payment amount must be greater than 0");
        return;
      }
      */

      const categoryObj = tenantCategories?.find((item) => item?.id === Number(selectedType));
      const paymentCategory = categoryObj?.category || "RENT";
      const currentLeaseObj = isMember ? selectedLeaseObj : currentLease;

      console.log("Getting payment token from backend...");
      const response = await API.graphql(
        graphqlOperation(getorcreateForteCustomerToken, {
          tenant_id: user?.id,
          property_lease_id: currentLeaseObj?.id,
          amount: amount,
          payment_category: paymentCategory,
          property_unit_id: currentLeaseObj?.property_unit_id.toString(),
          payment_date: moment(selectedDate).format("YYYY-MM-DD"),
          forte_org_id: forteMappingData?.forte_org_id || "",
          forte_location_id: forteMappingData?.forte_location_id || "",
        })
      );

      const lambdaResponse = response?.data?.getorcreateForteCustomerToken;

      // Store the response for later refreshes
      lastLambdaResponse.current = lambdaResponse;

      if (lambdaResponse?.status === 200) {
        // Get fresh UTC ticks
        const utcTicks = await getForteUTCTicks();

        // Parse the response if it's a string, otherwise use it directly
        let parsedResponse;
        try {
          parsedResponse =
            typeof lambdaResponse.response === "string" ? JSON.parse(lambdaResponse.response) : lambdaResponse.response;
        } catch (e) {
          console.error("Error parsing response:", e);
          parsedResponse = {};
        }

        // logging for UTCTicks received from backend and sent to Forte checkout
        console.log("Lambda response:", lambdaResponse);
        console.log("Parsed response:", parsedResponse);
        console.log("Signature value:", parsedResponse.signature);
        console.log("Backend UTC timestamp:", parsedResponse.timestamp);
        console.log("Current UTCTicks to be used:", utcTicks);
        console.log("Difference between timestamps:", Number(utcTicks) - Number(parsedResponse.timestamp));


        // Update button attributes directly
        const forteButton = document.getElementById("forte-init-button");

        if (forteButton) {
          // Create a signature payload object for logging
          const signaturePayload = {
            api_access_id: parsedResponse.api_access_id || "ff1572b26408215cfc4fec6f2309be9b",
            method: "sale",
            version_number: "2.0",
            total_amount: amount,
            utc_time: utcTicks,
            order_number: parsedResponse.order_number || "TESTORDERNUMBER",
            customer_token: parsedResponse.token,
            paymethod_token: ""
          };

          // Log the exact payload that would be used for signature generation
          console.log("Signature payload object:", signaturePayload);
          console.log("Signature payload string (pipe-delimited):", 
            [
              signaturePayload.api_access_id,
              signaturePayload.method,
              signaturePayload.version_number,
              signaturePayload.total_amount,
              signaturePayload.utc_time,
              signaturePayload.order_number,
              signaturePayload.customer_token,
              signaturePayload.paymethod_token
            ].join("|")
          );

          // logging for Forte button attributes
          console.log("Forte button attributes:", forteButton.attributes);
          console.log("Setting up Forte callback with name: oncallback");
          
          forteButton.setAttribute("api_access_id", parsedResponse.api_access_id);
          forteButton.setAttribute(
            "location_id",
            parsedResponse.payload?.locationId || forteMappingData.forte_location_id);
          forteButton.setAttribute("order_number", parsedResponse.order_number || "TESTORDERNUMBER");
          forteButton.setAttribute("signature", parsedResponse.signature);
          forteButton.setAttribute("utc_time", parsedResponse.timestamp);
          forteButton.setAttribute("consumer_id", parsedResponse.payload?.customerId);
          forteButton.setAttribute("customer_token", parsedResponse.token);
          forteButton.setAttribute("total_amount", amount);
          forteButton.setAttribute("method", "sale");
          forteButton.setAttribute("version_number", "2.0");
          forteButton.setAttribute("hash_method", "sha256");
          forteButton.setAttribute("xdata_1", paymentCategory);
          forteButton.setAttribute("xdata_2", currentLeaseObj.id);
          forteButton.setAttribute("callback", "oncallback");
          forteButton.setAttribute("paymethod_token", "");

          if (parsedResponse.payload?.save_token !== undefined)
            forteButton.setAttribute("save_token", parsedResponse.payload.save_token);
          if (parsedResponse.payload?.editable !== undefined)
            forteButton.setAttribute("editable", parsedResponse.payload.editable);
          if (parsedResponse.payload?.propertyUnitId)
            forteButton.setAttribute("property_unit_id", parsedResponse.payload.propertyUnitId);
          if (parsedResponse.payload?.paymentDate)
            forteButton.setAttribute("payment_date", parsedResponse.payload.paymentDate);
        }

        console.log("Waiting for ForteCheckout to initialize");
        if (window.ForteCheckout) {
          console.log("Launching Forte checkout");
          window.ForteCheckout.launch({ id: "forte-init-button" });
        } else {
          throw new Error("ForteCheckout not available");
        }
      } else {
        throw new Error(lambdaResponse?.response || "Unable to generate payment signature");
      }
    } catch (err) {
      console.debug("ForteCheckout available:", !!window.ForteCheckout);
      console.debug("Button attributes:", document.getElementById("forte-init-button")?.attributes);
    }
  };

  /*  // Define handleSubmit outside of JSX using useCallback
  const handleSubmit = useCallback(() => {
    console.log("handleSubmit called");
    if (!window.ForteCheckout) {
      console.log("ForteCheckout not available - loading script");
      const script = document.createElement("script");
      script.src = "https://sandbox.forte.net/checkout/v2/js";
      script.async = true;
      script.onload = () => {
        console.log("Forte SDK script loaded successfully");
        // Now that script is loaded, get params and launch
        getSignedParamsAndLaunch();
      };
      script.onerror = (error) => {
        console.error("Error loading Forte SDK script:", error);
        toast.error("Unable to load payment system. Please try again.");
        setIsForteProcessing(false);
      };
      document.body.appendChild(script);
      return;
    }
    
    // Get signed params and launch
    getSignedParamsAndLaunch();
  }, [
    inputValues,
    dueAmount,
    inputAmount,
    tenantCategories,
    selectedType,
    isMember,
    selectedLeaseObj,
    currentLease,
    forteMappingData,
    user,
    selectedDate,
  ]);
*/

  return (
    <>
      <Row className="row">
        <Col xl={7} lg={12} className="block">
          <BalanceCard />
        </Col>
        <Col xl={5} lg={12} className="block d-none d-lg-block">
          <RentersInsurance isMember={isMember} tenantWidgets={tenantWidgets} />

          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="flex-grow-1">
                  <h4 className="card-title">Lease Summary</h4>
                </div>
              </div>
              <LeaseSummary
                propertyDetail={propertyDetail}
                leases={leases?.filter((lease) => lease?.is_expired !== 1)}
                unfilteredLeases={unfilteredLeases}
                isMember={isMember}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-body p-1">
              <div className="d-flex align-items-center mb-4">
                <div className="flex-grow-1">
                  <h4 className="card-title mx-4 mt-1">Your Address</h4>
                </div>
              </div>
              <Address propertyDetail={propertyDetail} propertyPhotos={propertyPhotos} />
            </div>
          </div>

          <div className="card d-none d-lg-block p-0 m-0">
            <div className="card-body">
              <h4 className="card-title">Property Manager</h4>
            </div>

            {propertyManagerInfo && <PropertyManager />}
          </div>
        </Col>
      </Row>
      <Modal
        show={showForteModal}
        className="modal-style-2"
        onHide={() => {
          setShowForteModal(false);
          resetValues();
        }}
        centered
      >
        <Modal.Body>
          <h4 className="mb-0 text-center">Choose Payment Amount & Date</h4>
          {/* Define formValues and handleSubmit at the top of the modal */}
          {/* handleSubmit is now defined at component level with useCallback */}
          {isMember && inputValues?.checkedPayPartial && (
            <>
              <h5 className="mt-4">Select Space ID</h5>
              <div className="select">
                <div className="select">
                  <select
                    value={selectedLeaseId}
                    onChange={(e) => {
                      const lease = leases?.find((lease) => lease.id === Number(e.target.value));
                      setSelectedLeaseId(e.target.value); // Update the selectedLeaseId with the selected option's value
                      setSelectedLeaseObj(lease);
                    }}
                  >
                    {!selectedLeaseId && <option value="">Select a space</option>} {/* Add a default option */}
                    {Object.entries(groupLeasesByUnit(leases?.filter((lease) => lease?.is_expired !== 1) || [])).map(
                      ([propertyUnitId, lease]) => (
                        // Assuming you want to display the first lease in each group for simplicity
                        <option key={lease.id} value={lease.id}>
                          {lease.unit_name} ( $
                          {Number(lease.available_balance) < 0 ? Number(lease.available_balance) : "0"})
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </>
          )}
          <div className="accordion accordion-flush accordion-v2 mt-4" id="accordion1">
            <div className="accordion-item">
              {currentLease?.has_nsf_fee === 1 && (
                <h5 className="text-center text-danger">
                  Failed or returned payments will result in an NSF fee in accordance to your lease agreement
                </h5>
              )}
              <h5 className="mt-4">Payment Type</h5>
              <Col xl={5} md={12}>
                <div className="select w-100">
                  <select
                    value={selectedType}
                    onChange={(e) => {
                      setSelectedType(Number(e.target.value));
                    }}
                  >
                    {tenantCategories?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item?.category}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              <h5 className="mt-4 mb-2 card-title">Current Account Balance</h5>
              <div>
                <span>
                  <strong className="price mt-4" style={{ fontSize: "28px" }}>
                    {selectedLeaseId !== "" && isMember
                      ? getMemberAccountBalance()
                      : dueAmount > 0
                      ? formatUSNumber(dueAmount)
                      : "-"}
                  </strong>
                </span>
              </div>
              <h5 className="mt-4 mb-2 card-title">Your bill is due on</h5>
              <div>
                <span>
                  <strong className="price mt-4" style={{ fontSize: "16px" }}>
                    {propertyDetail?.upcoming_due_date ? (
                      <span>{formatDate(propertyDetail.upcoming_due_date)}</span>
                    ) : (
                      "There is nothing for you to pay"
                    )}
                  </strong>
                </span>
              </div>
              {user?.restricted_status !== "SUSPENDED" ? (
                <>
                  <div className="mt-3">
                    <label className="mb-2">When should this payment be made?</label>
                    <KeyboardDatePicker
                      value={selectedDate}
                      className="form-control"
                      format="MM/DD/YYYY"
                      onChange={(date) => setSelectedDate(date)}
                      variant="inline" //static
                      disableToolbar
                      autoOk
                      InputAdornmentProps={{ position: "end" }}
                      keyboardIcon={<img src={CalenderIcon} />}
                      disablePast
                      disabled={true} // Disabled for Forte instant payments
                      // disabled={isMember && inputValues?.checkedPayFull}
                    />
                  </div>
                  <Row className="mt-3">
                    <Col xl={6}>
                      {/* LARGE SCREEN */}
                      <label className="d-flex align-items-center">
                        <span className="d-none d-xl-block">Full Balance </span>
                        {/* DISABLE ON SMALL SCREEN */}
                        <Form className="d-block d-xl-none">
                          <Form.Check type="radio" id={`full-balance-radio`}>
                            <Form.Check.Input
                              type="radio"
                              isValid={inputValues?.checkedPayFull ? true : false}
                              name="paymentOption"
                              checked={inputValues?.checkedPayFull}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setInputValues({ ...inputValues, checkedPayFull: true, checkedPayPartial: false });
                                  if (isMember) {
                                    setSelectedDate(new Date());
                                  }
                                }
                              }}
                            />
                          </Form.Check>
                        </Form>
                        <label
                          className={`d-block d-xl-none mx-2 ${inputValues?.checkedPayFull ? "primary-text" : ""}`}
                        >
                          Pay Full Balance
                        </label>
                      </label>
                      <FormInput
                        placeholder="$"
                        prefix="$"
                        type="maskInput"
                        label=""
                        name="rent"
                        value={dueAmount}
                        setValue={setRentAmount}
                        //setValue={setInputAmount}
                        guide={false}
                        thousandsSeparator
                        className="w-100"
                        disabled={true}
                      />
                    </Col>
                    <Col xl={6} className="d-flex align-items-center">
                      {/* SHWO ON LARGE SCREEN SCREEN */}
                      <Form className="d-none d-xl-block">
                        <Form.Check type="radio" id={`full-balance-radio`}>
                          <Form.Check.Input
                            type="radio"
                            isValid={inputValues?.checkedPayFull ? true : false}
                            name="paymentOption"
                            checked={inputValues?.checkedPayFull}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setInputValues({ ...inputValues, checkedPayFull: true, checkedPayPartial: false });
                                if (isMember) {
                                  setSelectedDate(new Date());
                                }
                              }
                            }}
                          />
                        </Form.Check>
                      </Form>
                      <label className={`mx-2 d-none d-xl-block ${inputValues?.checkedPayFull ? "primary-text" : ""}`}>
                        Pay Full Balance
                      </label>
                    </Col>
                  </Row>
                  {user?.restricted_status !== "FULL PAYMENT" && (
                    <Row className="mt-3">
                      <Col xl={6}>
                        <label className="d-flex align-items-center">
                          {/* LARGE SCREEN */}
                          <span className="d-none d-xl-block">Pay Specific Amount</span>
                          <Form className="d-block d-xl-none">
                            <Form.Check type="radio" id={`partial-balance-radio`}>
                              <Form.Check.Input
                                type="radio"
                                isValid={inputValues?.checkedPayPartial ? true : false}
                                name="paymentOption"
                                checked={inputValues?.checkedPayPartial}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setInputValues({ ...inputValues, checkedPayFull: false, checkedPayPartial: true });
                                  }
                                }}
                              />
                            </Form.Check>
                          </Form>
                          {/* SMALL SCREEN */}
                          <label
                            className={`d-block d-xl-none mx-2 ${inputValues?.checkedPayPartial ? "primary-text" : ""}`}
                          >
                            Pay Specific Amount
                          </label>
                        </label>
                        <FormInput
                          placeholder="$"
                          prefix="$"
                          type="maskInput"
                          label=""
                          name="payment_amount"
                          value={inputAmount}
                          setValue={setInputAmount}
                          guide={false}
                          thousandsSeparator
                          className="w-100"
                          disabled={inputValues?.checkedPayFull ? true : false}
                        />
                      </Col>
                      <Col xl={6} className="d-flex align-items-center">
                        <Form className="d-none d-xl-block">
                          <Form.Check type="radio" id={`partial-balance-radio`}>
                            <Form.Check.Input
                              type="radio"
                              isValid={inputValues?.checkedPayPartial ? true : false}
                              name="paymentOption"
                              checked={inputValues?.checkedPayPartial}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setInputValues({ ...inputValues, checkedPayFull: false, checkedPayPartial: true });
                                }
                              }}
                            />
                          </Form.Check>
                        </Form>
                        <label
                          className={`mx-2 d-none d-xl-block ${inputValues?.checkedPayPartial ? "primary-text" : ""}`}
                        >
                          Pay Specific Amount
                        </label>
                      </Col>
                    </Row>
                  )}{" "}
                </>
              ) : (
                <div>
                  <h3 className="mt-4 text-danger">Suspended</h3>
                  <p className="card-title">Please contact your Property Manager</p>
                </div>
              )}
            </div>
          </div>
          <div className="row modal-btns">
            <div className="col-6">
              <button type="button" className="btn btn-warning w-100" onClick={() => {
                setShowForteModal(false);
                resetValues();
              }}>
                Cancel
              </button>
            </div>
            <div className="col-6">
              <div style={{ width: "100%" }}>
                <button
                  id="forte-init-button"
                  api_access_id="ff1572b26408215cfc4fec6f2309be9b"
                  method="sale"
                  version_number="2.0"
                  hash_method="sha256"
                  location_id="373367"
                  order_number="TESTORDERNUMBER"
                  signature="placeholder"
                  utc_time="000000000000000000"
                  customer_token="placeholder"
                  callback="oncallback"
                  ref={forteButtonRef}
                  className="btn btn-primary w-100"
                  style={{
                    padding: "12px",
                    width: "100%",
                    backgroundColor: "#007bff",
                    color: "white",
                    marginBottom: "15px",
                  }}
                  type="button"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal-style-2"
        centered
        show={scheduledPaymentSuccessModal}
        onHide={handleCloseScheduledPaymentsSuccess}
        size="md"
      >
        <Modal.Body>
          <h4 className="mb-0 text-center mb-4" style={{ textAlign: "center" }}>
            Scheduled Payment Successful
          </h4>
          <table className="table">
            {successfulPaymentScreenEditMode ? (
              <>
                <thead>
                  <tr>
                    <th style={{ fontWeight: "normal" }}>Date</th>
                    <th style={{ fontWeight: "normal" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: 175 }}>
                      <div className="mt-2">
                        <KeyboardDatePicker
                          onChange={(date) => {
                            setEditModeDate(moment(date).format("YYYY-MM-DD"));
                          }}
                          value={editModeDate}
                          className={`form-control`}
                          format="YYYY-MM-DD"
                          variant="inline" //static
                          disableToolbar
                          autoOk
                          InputAdornmentProps={{ position: "end" }}
                          keyboardIcon={<img src={CalenderIcon} />}
                          disablePast
                          error={false}
                          helperText={null}
                        />
                      </div>
                    </td>
                    <td style={{ width: 100 }}>
                      <FormInput
                        placeholder="$"
                        prefix="$"
                        type="maskInput"
                        name="edit_mode_amount"
                        value={editModeAmount}
                        setValue={setEditModeAmount}
                        guide={false}
                        thousandsSeparator
                      />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <thead>
                  <tr>
                    <th style={{ fontWeight: "normal" }}>Payment Type</th>
                    <th style={{ fontWeight: "normal" }} className="text-center">
                      Date
                    </th>
                    <th style={{ fontWeight: "normal" }}>Amount</th>
                    <th style={{ fontWeight: "normal" }} className="text-center">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{tenantCategories?.find((item) => item?.id === editModeCategory)?.category}</td>

                    <td>{moment(editModeDate).format("YYYY-MM-DD")}</td>
                    <td className="text-center">${numberWithCommas(Number(editModeAmount))}</td>
                    <td>
                      {moment(editModeDate).isSame(moment(), "day") ? (
                        <label className="payment-status badge bg-blue">Pending</label>
                      ) : (
                        <span
                          style={{
                            border: "1px solid #CCCCCC",
                            color: "#CCCCCC",
                            padding: "3px 6px",
                            borderRadius: "15px",
                          }}
                        >
                          Scheduled
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </>
            )}
          </table>
          <Row>
            <Col lg={6} xs={6}>
              <button
                className="w-100 btn btn-inverse mt-2"
                type="button"
                onClick={() => handleEditSuccessfulPayment()}
              >
                Edit
              </button>
            </Col>
            <Col lg={6} xs={6}>
              <button
                className="w-100 btn btn-primary mt-2"
                onClick={async () => {
                  if (successfulPaymentScreenEditMode) {
                    await handleSaveEditPayment();
                  } else {
                    handleCloseScheduledPaymentsSuccess();
                  }
                  //handleSaveEditPayment();
                }}
              >
                {successfulPaymentScreenEditMode ? "Save" : "Done"}
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal-style-1"
        centered
        show={automaticShow}
        onHide={() => {
          resetValues();
          handleClose();
        }}
      >
        <Modal.Body>
          <h4 className="mb-0 modal-header">Automatic Payment</h4>
          <p>
            Payments will be withdrawn each month on your due date. (If your due date falls on a Saturday, we'll make
            your payment on the Friday before).
          </p>
          <div className="accordion accordion-flush accordion-v2">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed schedule-date-btn"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Pay From
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordion1"
              >
                <div className="accordion-body">
                  <div className="select">
                    <select
                      defaultValue={
                        bankAccounts?.find((item) => item?.default_bank_account === 1)
                          ? JSON.stringify(bankAccounts.find((item) => item?.default_bank_account === 1))
                          : "hide"
                      }
                      onChange={(e) => {
                        e.preventDefault();
                        if (e.target.value) {
                          setSelectedBankAccount(JSON.parse(e.target.value));
                        }
                      }}
                    >
                      <option disabled value="hide">
                        {bankAccounts.length > 0 ? "Select Bank Account" : "You have not added any bank account"}
                      </option>

                      {bankAccounts?.map((bank, index) => (
                        <option key={index} value={JSON.stringify(bank)}>
                          **** **** **** {bank?.account_number}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="text-center py-3 fw-bold">or</div>
                  <AddBankAccount
                    getAllBankAccounts={getAllBankAccounts}
                    setLoading={setLoading}
                    isFromDashboard={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col xs={6}>
              <Button variant="warning" className="w-100" onClick={handleClose}>
                Close
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                variant="primary"
                disabled={!selectedBankAccount}
                className="w-100"
                onClick={() => {
                  updateModalShow("automaticPaymentScheduleShow", true);
                  setAutomaticShow(false);
                }}
              >
                Continue
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal show={confirmation} onHide={() => setConfirmation(false)} className="modal-style-1 confirm-model" centered>
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Rent Payment Transaction Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center mb-3">
          <p>
            You already have a rent payment in progress. Submitting again will charge you a
            second time.
          </p>
          {checkTransaction?.map((t) => (
            <div
              key={t?.id}
              className="pending-payment-summary border rounded p-2 my-2 text-start"
            >
              <div>
                <strong>${numberWithCommas(t?.amount)}</strong>
                {t?.category ? ` — ${t.category}` : ""}
              </div>
              <div className="text-muted">
                Payment date {formatDate(t?.date)} · Status: Pending
              </div>
            </div>
          ))}
          <p className="mt-2 mb-0">Are you sure you want to make another payment?</p>
        </Modal.Body>
        <Modal.Footer>
          <Row className="w-100">
            <Col xs={6}>
              <button className="btn btn-inverse w-100" onClick={() => setConfirmation(false)}>
                Cancel
              </button>
            </Col>
            <Col xs={6}>
              <Button
                type="submit"
                className=" w-100"
                onClick={async () => {
                  track(EVENTS.DUPLICATE_PAYMENT_CONFIRMED, {});
                  return setConfirmation(false), await handelPayment(true);
                }}
              >
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deactivatedAutomaticPaymentModalShow}
        onHide={() => setDeactivatedAutomaticPaymentModalShow(false)}
        className="modal-style-1"
        centered
      >
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Automatic Payment Deactivated
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center mb-3">
          You have successfully deactivated automatic payments, you will be required and reminded to login and manually
          schedule or pay the rent amount each month.
          <p></p>
          <p>To reactive automatic payments, simply select the toggle on your payment details card.</p>
        </Modal.Body>
        <Modal.Footer>
          <Container>
            <Row>
              <Col xs={12}>
                <Button
                  type="submit"
                  className=" w-100"
                  onClick={() => {
                    setDeactivatedAutomaticPaymentModalShow(false);
                  }}
                >
                  Done
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
      {/* General Payment Form Confirmation Modal */}
      <PaymentConfirmedModal
        show={allModals?.paymentConfirmationShow}
        amount={inputValues?.checkedPayFull ? formatUSNumber(dueAmount) || "-" : formatUSNumber(submittedAmount) || "-"}
        date={moment(selectedDate)?.format("MM/DD/YYYY")}
        updateModalShow={modalToggler("paymentConfirmationShow")}
        resetValues={resetValues}
        // isScheduled={moment(selectedDate)?.isSame(moment(), "day") ? false : true} // ARR-1417 - commented this logic to test a different way of evaluating this condition
        isScheduled={moment(selectedDate).isAfter(moment(), "day")}
        title={
          moment(selectedDate).isAfter(moment(), "day") ? "Payment Scheduled" : "Payment Initiated"
        } /* ARR-1417 - adjusted modal text to reflect Tenant Payment Scheduled or Initiated with Notice 24 Hours to Withdraw from Bank Account */
      />
      {/*  Automatic Payment Form Confirmation Modal*/}
      <AutomaticPaymentScheduleModal
        show={allModals?.automaticPaymentScheduleShow}
        updateModalShow={modalToggler("automaticPaymentScheduleShow")}
        automaticPayment={automaticPayment}
        amount={currentLease?.rent}
        nextDueDate={propertyDetail?.upcoming_due_date}
        resetValues={resetValues}
        isMember={isMember}
      />
      <PaymentConfirmedModal
        show={allModals?.automaticPaymentConfirmationShow}
        amount={formatUSNumber(submittedAutomaticPaymentAmount) || "-"}
        date={moment(submittedAutomaticPaymentDate)?.format("MM/DD/YYYY")}
        updateModalShow={modalToggler("automaticPaymentConfirmationShow")}
        resetValues={resetValues}
        isScheduled={true}
        title={"Autopay Scheduled"}
        isAutopay={true}
      />
      <Modal
        show={allModals?.rentMismatchModal}
        onHide={handleAutopayUpdateNo}
        className="modal-style-1"
        centered
      >
        <Modal.Header>
          <Modal.Title as="h3" className="w-100 text-center">
            Rent Amount Updated
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">
            Your rent has been updated to{" "}
            <strong>${numberWithCommas(currentLease?.rent)}</strong>.
            {pendingAutopayRecord && (
              <>
                {" "}Your autopay is currently set to{" "}
                <strong>${numberWithCommas(pendingAutopayRecord?.payment_amount)}</strong>.
                Would you like to update your autopay to match your new rent?
              </>
            )}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center flex-column gap-2">
          {pendingAutopayRecord && (
            <Button variant="primary" className="w-100" onClick={handleAutopayUpdateYes}>
              Yes, update my autopay to ${numberWithCommas(currentLease?.rent)}
            </Button>
          )}
          <Button variant="warning" className="w-100" onClick={handleAutopayUpdateNo}>
            {pendingAutopayRecord ? "Keep my current autopay amount" : "Dismiss"}
          </Button>
        </Modal.Footer>
      </Modal>
      <PaymentMethodSelectionModal
        title="Select Payment Method"
        show={allModals?.paymentMethodSelectionShow}
        updateModalShow={modalToggler("paymentMethodSelectionShow")}
        resetValues={resetValues}
        bankAccounts={bankAccounts}
        selectedBankAccount={selectedBankAccount}
        setSelectedBankAccount={setSelectedBankAccount}
        setLoading={setLoading}
        getAllBankAccounts={getAllBankAccounts}
        setAutoPaymentBank={setAutoPaymentBank}
        callbackFunction={() => {
          setPayRentModalShow(true);
        }}
      />
      <CreditCardPaymentModal
        title="Credit Card Payment"
        show={allModals?.creditCardPaymentShow}
        updateModalShow={modalToggler("creditCardPaymentShow")}
        resetValues={resetValues}
        setLoading={setLoading}
        setAutoPaymentBank={setAutoPaymentBank}
        callbackFunction={beginCreditCardPayment}
        propertyDetail={propertyDetail}
        leases={leases}
        dueAmount={dueAmount}
        setRentAmount={setRentAmount}
        tenantCategories={tenantCategories}
      />
      <Modal
        className="modal-style-2"
        centered
        show={payRentModalShow}
        onHide={() => {
          resetValues();
          setPayRentModalShow(false);
        }}
      >
        <Modal.Body>
          <h4 className="mb-0 text-center">Choose Payment Amount & Date</h4>
          {isMember && inputValues?.checkedPayPartial && (
            <>
              <h5 className="mt-4">Select Space ID</h5>
              <div className="select">
                <div className="select">
                  <select
                    value={selectedLeaseId}
                    onChange={(e) => {
                      const lease = leases?.find((lease) => lease.id === Number(e.target.value));
                      setSelectedLeaseId(e.target.value); // Update the selectedLeaseId with the selected option's value
                      setSelectedLeaseObj(lease);
                    }}
                  >
                    {!selectedLeaseId && <option value="">Select a space</option>} {/* Add a default option */}
                    {Object.entries(groupLeasesByUnit(leases?.filter((lease) => lease?.is_expired !== 1) || [])).map(
                      ([propertyUnitId, lease]) => (
                        // Assuming you want to display the first lease in each group for simplicity
                        <option key={lease.id} value={lease.id}>
                          {lease.unit_name} ( $
                          {Number(lease.available_balance) < 0 ? Number(lease.available_balance) : "0"})
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </>
          )}
          <div className="accordion accordion-flush accordion-v2 mt-4" id="accordion1">
            <div className="accordion-item">
              {currentLease?.has_nsf_fee === 1 && (
                <h5 className="text-center text-danger">
                  Failed or returned payments will result in an NSF fee in accordance to your lease agreement
                </h5>
              )}
              <h5 className="mt-4">Payment Type</h5>
              <Col xl={5} md={12}>
                <div className="select w-100">
                  <select
                    value={selectedType}
                    onChange={(e) => {
                      setSelectedType(Number(e.target.value));
                    }}
                  >
                    {tenantCategories?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item?.category}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              <h5 className="mt-4 mb-2 card-title">Current Account Balance</h5>
              <div>
                <span>
                  <strong className="price mt-4" style={{ fontSize: "28px" }}>
                    {selectedLeaseId !== "" && isMember
                      ? getMemberAccountBalance()
                      : dueAmount > 0
                      ? formatUSNumber(dueAmount)
                      : "-"}
                  </strong>
                </span>
              </div>
              <h5 className="mt-4 mb-2 card-title">Your bill is due on</h5>
              <div>
                <span>
                  <strong className="price mt-4" style={{ fontSize: "16px" }}>
                    {propertyDetail?.upcoming_due_date ? (
                      <span>{formatDate(propertyDetail.upcoming_due_date)}</span>
                    ) : (
                      "There is nothing for you to pay"
                    )}
                  </strong>
                </span>
              </div>
              {user?.restricted_status !== "SUSPENDED" ? (
                <>
                  <div className="mt-3">
                    <label className="mb-2">When should this payment be made?</label>
                    <KeyboardDatePicker
                      value={selectedDate}
                      className="form-control"
                      format="MM/DD/YYYY"
                      onChange={(date) => setSelectedDate(date)}
                      variant="inline" //static
                      disableToolbar
                      autoOk
                      InputAdornmentProps={{ position: "end" }}
                      keyboardIcon={<img src={CalenderIcon} />}
                      disablePast
                      disabled={isMember && inputValues?.checkedPayFull}
                    />
                  </div>
                  <Row className="mt-3">
                    <Col xl={6}>
                      {/* LARGE SCREEN */}
                      <label className="d-flex align-items-center">
                        <span className="d-none d-xl-block">Full Balance </span>
                        {/* DISABLE ON SMALL SCREEN */}
                        <Form className="d-block d-xl-none">
                          <Form.Check type="radio" id={`full-balance-radio`}>
                            <Form.Check.Input
                              type="radio"
                              isValid={inputValues?.checkedPayFull ? true : false}
                              name="paymentOption"
                              checked={inputValues?.checkedPayFull}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setInputValues({ ...inputValues, checkedPayFull: true, checkedPayPartial: false });
                                  if (isMember) {
                                    setSelectedDate(new Date());
                                  }
                                }
                              }}
                            />
                          </Form.Check>
                        </Form>
                        <label
                          className={`d-block d-xl-none mx-2 ${inputValues?.checkedPayFull ? "primary-text" : ""}`}
                        >
                          Pay Full Balance
                        </label>
                      </label>
                      <FormInput
                        placeholder="$"
                        prefix="$"
                        type="maskInput"
                        label=""
                        name="rent"
                        value={dueAmount}
                        setValue={setRentAmount}
                        //setValue={setInputAmount}
                        guide={false}
                        thousandsSeparator
                        className="w-100"
                        disabled={true}
                      />

                      {/*
                  <input
                    className="form-control"
                    type="text"
                    id="amount"
                    value={`$${inputAmount}`}
                    onChange={(e) => {
                      const value = formatCurrency(e);
                      if (value) {
                        setInputAmount(value);
                      }
                    }}
                  />
                  */}
                    </Col>
                    <Col xl={6} className="d-flex align-items-center">
                      {/* SHWO ON LARGE SCREEN SCREEN */}
                      <Form className="d-none d-xl-block">
                        <Form.Check type="radio" id={`full-balance-radio`}>
                          <Form.Check.Input
                            type="radio"
                            isValid={inputValues?.checkedPayFull ? true : false}
                            name="paymentOption"
                            checked={inputValues?.checkedPayFull}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setInputValues({ ...inputValues, checkedPayFull: true, checkedPayPartial: false });
                                if (isMember) {
                                  setSelectedDate(new Date());
                                }
                              }
                            }}
                          />
                        </Form.Check>
                      </Form>
                      <label className={`mx-2 d-none d-xl-block ${inputValues?.checkedPayFull ? "primary-text" : ""}`}>
                        Pay Full Balance
                      </label>
                    </Col>
                  </Row>
                  {user?.restricted_status !== "FULL PAYMENT" && (
                    <Row className="mt-3">
                      <Col xl={6}>
                        <label className="d-flex align-items-center">
                          {/* LARGE SCREEN */}
                          <span className="d-none d-xl-block">Pay Specific Amount</span>
                          <Form className="d-block d-xl-none">
                            <Form.Check type="radio" id={`partial-balance-radio`}>
                              <Form.Check.Input
                                type="radio"
                                isValid={inputValues?.checkedPayPartial ? true : false}
                                name="paymentOption"
                                checked={inputValues?.checkedPayPartial}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setInputValues({ ...inputValues, checkedPayFull: false, checkedPayPartial: true });
                                  }
                                }}
                              />
                            </Form.Check>
                          </Form>
                          {/* SMALL SCREEN */}
                          <label
                            className={`d-block d-xl-none mx-2 ${inputValues?.checkedPayPartial ? "primary-text" : ""}`}
                          >
                            Pay Specific Amount
                          </label>
                        </label>
                        <FormInput
                          placeholder="$"
                          prefix="$"
                          type="maskInput"
                          label=""
                          name="payment_amount"
                          value={inputAmount}
                          setValue={setInputAmount}
                          guide={false}
                          thousandsSeparator
                          className="w-100"
                          disabled={inputValues?.checkedPayFull ? true : false}
                        />
                      </Col>
                      <Col xl={6} className="d-flex align-items-center">
                        <Form className="d-none d-xl-block">
                          <Form.Check type="radio" id={`partial-balance-radio`}>
                            <Form.Check.Input
                              type="radio"
                              isValid={inputValues?.checkedPayPartial ? true : false}
                              name="paymentOption"
                              checked={inputValues?.checkedPayPartial}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setInputValues({ ...inputValues, checkedPayFull: false, checkedPayPartial: true });
                                }
                              }}
                            />
                          </Form.Check>
                        </Form>
                        <label
                          className={`mx-2 d-none d-xl-block ${inputValues?.checkedPayPartial ? "primary-text" : ""}`}
                        >
                          Pay Specific Amount
                        </label>
                      </Col>
                      {/*
                  <input
                    className="form-control"
                    type="text"
                    id="amount"
                    value={`$${inputAmount}`}
                    onChange={(e) => {
                      const value = formatCurrency(e);
                      if (value) {
                        setInputAmount(value);
                      }
                    }}
                  />
                  */}
                    </Row>
                  )}{" "}
                </>
              ) : (
                <div>
                  <h3 className="mt-4 text-danger">Suspended</h3>
                  <p className="card-title">Please contact your Property Manager</p>
                </div>
              )}
            </div>
            {/*
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed schedule-date-btn"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                  data-cy="payfrom"
                >
                  Pay From
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordion1"
              >
                <div className="accordion-body">
                  <div className="select">
                    <select
                      data-cy="bankaccount"
                      defaultValue={
                        bankAccounts?.find((item) => item?.default_bank_account === 1)
                          ? JSON.stringify(bankAccounts.find((item) => item?.default_bank_account === 1))
                          : "hide"
                      }
                      onChange={(e) => {
                        e.preventDefault();
                        if (e.target.value) {
                          setSelectedBankAccount(JSON.parse(e.target.value));
                          setAutoPaymentBank();
                        }
                      }}
                    >
                      <option disabled value="hide">
                        {bankAccounts.length > 0 ? "Select Bank Account" : "You have not added any bank account"}
                      </option>

                      {bankAccounts
                        ?.filter((bank) => bank.status !== "pending_manual_verification")
                        ?.map((bank, index) => (
                          <option key={index} value={JSON.stringify(bank)}>
                            **** **** **** {bank?.account_number}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="text-center py-3 fw-bold">or</div>
                  <AddBankAccount
                    getAllBankAccounts={getAllBankAccounts}
                    setLoading={setLoading}
                    isFromDashboard={true}
                  />
                </div>
              </div>
            </div>
*/}
          </div>
          <div className="row modal-btns">
            <div className="col-6">
              <button type="button" className="btn btn-warning w-100" onClick={() => setPayRentModalShow(false)}>
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button
                disabled={!selectedBankAccount || user?.restricted_status === "SUSPENDED"}
                onClick={() => handelPayment()}
                type="button"
                className="btn btn-primary w-100"
                data-cy="continue"
              >
                Continue
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentDues;
